import React, { useState, useEffect, useCallback } from 'react';
import { downloadWord, buildAgendaItems, buildNoticeHtml, buildMinutesHtml, buildAttendanceHtml, buildCtcHtml, buildShorterConsentHtml, noticeGapDays, requiredNoticeDays } from './documentGenerators';
import { getEntityProfile } from '../../constants/mcaEntity';
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ── ICONS ──────────────────────────────────────────────────────────────────
const Icons = {
  boardMeeting: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="3" width="18" height="18" rx="3"/>
      <path d="M8 10h8M8 14h5"/><circle cx="17" cy="14" r="2.5"/>
    </svg>
  ),
  generalMeeting: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  committee: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="8" r="4"/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
      <line x1="12" y1="14" x2="12" y2="20"/>
      <line x1="9" y1="17" x2="15" y2="17"/>
    </svg>
  ),
  members: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="8" y1="13" x2="16" y2="13"/>
      <line x1="8" y1="17" x2="12" y2="17"/>
    </svg>
  ),
  directors: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
      <polyline points="16 11 18 13 22 9"/>
    </svg>
  ),
  charges: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="1" y="4" width="22" height="16" rx="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  ),
  contracts: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <path d="M9 15l2 2 4-4"/>
    </svg>
  ),
  certificates: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="8" r="6"/>
      <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
    </svg>
  ),
  allotment: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
  transfers: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <polyline points="17 1 21 5 17 9"/>
      <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
      <polyline points="7 23 3 19 7 15"/>
      <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
    </svg>
  ),
  back: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  close: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  add: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  edit: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  delete: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="3 6 5 6 21 6"/>
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
      <path d="M10 11v6M14 11v6"/>
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    </svg>
  ),
  kebab: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/>
    </svg>
  ),
  search: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  building: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
    </svg>
  ),
};

// ── REGISTER CATALOGUE ─────────────────────────────────────────────────────
const REGISTERS = [
  {
    id: 'board-meetings',
    label: 'Board Meeting Register',
    section: 'Meetings',
    description: 'Record of all board meetings as per SS-1 and Section 118',
    icon: Icons.boardMeeting,
    color: '#00206E',
    lightBg: '#eff6ff',
    badge: 'SS-1 · Sec 118',
    source: 'new',
  },
  {
    id: 'general-meetings',
    label: 'General Meeting Register',
    section: 'Meetings',
    description: 'AGM, EGM and Postal Ballot records as per SS-2 and Section 101',
    icon: Icons.generalMeeting,
    color: '#7c3aed',
    lightBg: '#f5f3ff',
    badge: 'SS-2 · Sec 101',
    source: 'new',
  },
  {
    id: 'committee-meetings',
    label: 'Committee Meeting Register',
    section: 'Meetings',
    description: 'Audit, NRC, CSR and other committee meeting records',
    icon: Icons.committee,
    color: '#0891b2',
    lightBg: '#ecfeff',
    badge: 'Sec 177 · 178',
    source: 'new',
  },
  {
    id: 'members',
    label: 'Register of Members',
    section: 'Share Records',
    description: 'MGT-1 format shareholder register as per Section 88',
    icon: Icons.members,
    color: '#059669',
    lightBg: '#ecfdf5',
    badge: 'MGT-1 · Sec 88',
    source: 'shareholders',
  },
  {
    id: 'directors',
    label: 'Register of Directors & KMP',
    section: 'People Records',
    description: 'MBP-1 format director and KMP register as per Section 170',
    icon: Icons.directors,
    color: '#d97706',
    lightBg: '#fffbeb',
    badge: 'MBP-1 · Sec 170',
    source: 'directors',
  },
  {
    id: 'charges',
    label: 'Register of Charges',
    section: 'Finance Records',
    description: 'CHG-7 format charge register as per Section 85',
    icon: Icons.charges,
    color: '#dc2626',
    lightBg: '#fef2f2',
    badge: 'CHG-7 · Sec 85',
    source: 'new',
  },
  {
    id: 'contracts',
    label: 'Register of Contracts — AOC-2',
    section: 'Finance Records',
    description: 'Related party contracts and arrangements as per Section 189',
    icon: Icons.contracts,
    color: '#FF8400',
    lightBg: '#fff7ed',
    badge: 'AOC-2 · Sec 189',
    source: 'new',
  },
  {
    id: 'certificates',
    label: 'Register of Share Certificates',
    section: 'Share Records',
    description: 'Share certificate issuance and cancellation records',
    icon: Icons.certificates,
    color: '#00206E',
    lightBg: '#eff6ff',
    badge: 'SH-1 · Sec 46',
    source: 'shareholders',
  },
  {
    id: 'allotment',
    label: 'Register of Allotment',
    section: 'Share Records',
    description: 'PAS-3 based allotment register as per Section 42',
    icon: Icons.allotment,
    color: '#7c3aed',
    lightBg: '#f5f3ff',
    badge: 'PAS-3 · Sec 42',
    source: 'shareholders',
  },
  {
    id: 'transfers',
    label: 'Share Transfer Register',
    section: 'Share Records',
    description: 'SH-4 based share transfer records as per Section 56',
    icon: Icons.transfers,
    color: '#0891b2',
    lightBg: '#ecfeff',
    badge: 'SH-4 · Sec 56',
    source: 'transfers',
  },
];

const SECTIONS = ['Meetings', 'Share Records', 'People Records', 'Finance Records'];

// ── INPUT CLASS ─────────────────────────────────────────────────────────────
const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-[#00206E] bg-white";

// ── STATUS BADGE ────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const map = {
    'Scheduled': { bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
    'Held': { bg: '#ecfdf5', color: '#059669', border: '#a7f3d0' },
    'Adjourned': { bg: '#fffbeb', color: '#d97706', border: '#fde68a' },
    'Cancelled': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
    'Active': { bg: '#ecfdf5', color: '#059669', border: '#a7f3d0' },
    'Satisfied': { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' },
    'Minutes Pending': { bg: '#fff7ed', color: '#FF8400', border: '#fed7aa' },
  };
  const s = map[status] || { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb' };
  return (
    <span style={{
      padding: '2px 8px', borderRadius: '20px', fontSize: '11px',
      fontWeight: 600, background: s.bg, color: s.color,
      border: `1px solid ${s.border}`,
    }}>
      {status}
    </span>
  );
}

// ── COMPANY SELECTOR ────────────────────────────────────────────────────────
function CompanySelector({ companies, onSelect, registerLabel, registerIcon, registerColor }) {
  const [search, setSearch] = useState('');
  const filtered = companies.filter(c =>
    !search ||
    c.company_name?.toLowerCase().includes(search.toLowerCase()) ||
    c.cin_llpin?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="rounded-2xl overflow-hidden" style={{ background: `linear-gradient(135deg, ${registerColor}15, ${registerColor}08)`, border: `1px solid ${registerColor}25` }}>
        <div className="px-6 py-5 flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-sm" style={{ background: registerColor, color: 'white' }}>
            {registerIcon}
          </div>
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">{registerLabel}</p>
            <p className="text-xs text-gray-500 mt-0.5">Select a company to view its register</p>
          </div>
        </div>
      </div>

      {/* Search + List */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">{Icons.search}</span>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search company name or CIN..."
              className="w-full pl-9 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#00206E] bg-gray-50 focus:bg-white transition"
            />
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="py-16 text-center">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-3" style={{ background: '#f5f5f7' }}>
              {Icons.building}
            </div>
            <p className="text-sm font-semibold text-gray-500">No companies found</p>
            <p className="text-xs text-gray-400 mt-1">Add companies via Company Master first</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {filtered.map(c => (
              <button
                key={c.id}
                onClick={() => onSelect(c)}
                className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition text-left group"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold text-white flex-shrink-0" style={{ background: '#00206E' }}>
                    {c.company_name.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-800 group-hover:text-[#00206E] transition">{c.company_name}</p>
                    <p className="text-xs text-gray-400 mt-0.5">
                      {c.company_type}
                      {c.cin_llpin && ` · ${c.cin_llpin}`}
                      {c.roc && ` · ${c.roc}`}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition">
                  <span className="text-xs font-semibold" style={{ color: '#FF8400' }}>Open Register</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FF8400" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── BOARD MEETING REGISTER ──────────────────────────────────────────────────
export function BoardMeetingRegister({ company, onBack, entity }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  // LLPs have no statutory board meeting — this becomes a non-statutory
  // "Partners' Meetings & Decisions" register (per the LLP Agreement).
  const llp = !!entity?.isLLP;

  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  const EMPTY = {
    serial_number: '', meeting_type: llp ? "Partners' Meeting" : 'Board Meeting', meeting_number: '',
    meeting_date: '', meeting_day: '', meeting_time: '',
    venue: '', mode: 'Physical', notice_date: '', notice_mode: 'Email',
    total_strength: '', quorum_required: '', quorum_present: true,
    chairman: '', company_secretary: '',
    mgt14_required: false, mgt14_srn: '', mgt14_filed_date: '',
    minutes_signed_date: '', minutes_signed_by: '',
    next_meeting_date: '', status: 'Scheduled', notes: '',
  };
  const [form, setForm] = useState(EMPTY);

  const fetchMeetings = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings`, { headers });
      const data = await res.json();
      setMeetings(Array.isArray(data) ? data : []);
    } catch (e) { setMeetings([]); }
    finally { setLoading(false); }
  }, [company.id]);

  useEffect(() => {
    fetchMeetings();
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [fetchMeetings]);

  // Auto-calculate day of week
  useEffect(() => {
    if (form.meeting_date) {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const day = days[new Date(form.meeting_date).getDay()];
      setForm(f => ({ ...f, meeting_day: day }));
    }
  }, [form.meeting_date]);

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/board-meetings/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/board-meetings`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message || 'Could not save'); return; }
      await fetchMeetings();
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = m => {
    setForm({
      serial_number: m.serial_number || '',
      meeting_type: m.meeting_type || 'Board Meeting',
      meeting_number: m.meeting_number || '',
      meeting_date: m.meeting_date ? String(m.meeting_date).slice(0, 10) : '',
      meeting_day: m.meeting_day || '',
      meeting_time: m.meeting_time || '',
      venue: m.venue || '',
      mode: m.mode || 'Physical',
      notice_date: m.notice_date ? String(m.notice_date).slice(0, 10) : '',
      notice_mode: m.notice_mode || 'Email',
      total_strength: m.total_strength || '',
      quorum_required: m.quorum_required || '',
      quorum_present: m.quorum_present !== false,
      chairman: m.chairman || '',
      company_secretary: m.company_secretary || '',
      mgt14_required: m.mgt14_required || false,
      mgt14_srn: m.mgt14_srn || '',
      mgt14_filed_date: m.mgt14_filed_date ? String(m.mgt14_filed_date).slice(0, 10) : '',
      minutes_signed_date: m.minutes_signed_date ? String(m.minutes_signed_date).slice(0, 10) : '',
      minutes_signed_by: m.minutes_signed_by || '',
      next_meeting_date: m.next_meeting_date ? String(m.next_meeting_date).slice(0, 10) : '',
      status: m.status || 'Scheduled',
      notes: m.notes || '',
    });
    setEditingId(m.id);
    setShowForm(true);
  };

  const handleDelete = async m => {
    if (!window.confirm(`Delete meeting "${m.meeting_number || m.meeting_type}"?`)) return;
    try {
      await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${m.id}`, { method: 'DELETE', headers });
      await fetchMeetings();
    } catch (e) { alert('Server error'); }
  };

  if (selectedMeeting) {
    return (
      <MeetingDetail
        meeting={selectedMeeting}
        company={company}
        entity={entity}
        onBack={() => setSelectedMeeting(null)}
        headers={headers}
      />
    );
  }

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && (
            <button
              onClick={onBack}
              className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition"
            >
              {Icons.back}
            </button>
          )}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">{llp ? "Partners' Meetings & Decisions" : 'Board Meeting Register'}</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · {llp ? 'Governed by the LLP Agreement (non-statutory)' : 'SS-1 · Section 118'}</p>
          </div>
        </div>
        <button
          onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold transition shadow-sm"
          style={{ background: '#00206E' }}
        >
          {Icons.add} Record Meeting
        </button>
      </div>

      {/* Stats Row */}
      <div className={`grid ${llp ? 'grid-cols-3' : 'grid-cols-4'} gap-4`}>
        {[
          { label: 'Total Meetings', value: meetings.length, color: '#00206E' },
          { label: 'Held', value: meetings.filter(m => m.status === 'Held').length, color: '#059669' },
          { label: 'Scheduled', value: meetings.filter(m => m.status === 'Scheduled').length, color: '#0891b2' },
          ...(llp ? [] : [{ label: 'MGT-14 Filed', value: meetings.filter(m => m.mgt14_required && m.mgt14_srn).length, color: '#FF8400' }]),
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <p className="text-2xl font-bold" style={{ color: s.color }}>{s.value}</p>
            <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Form */}
      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          {/* Form Header */}
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #eff6ff, #fff7ed)' }}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-sm" style={{ background: '#00206E' }}>
                {Icons.boardMeeting}
              </div>
              <div>
                <p className="text-sm font-bold" style={{ color: '#00206E' }}>
                  {editingId ? (llp ? "Edit Partners' Meeting" : 'Edit Board Meeting') : (llp ? "Record Partners' Meeting" : 'Record Board Meeting')}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">{llp ? 'Recorded per the LLP Agreement — not a statutory requirement' : 'As per SS-1 and Section 118 of Companies Act 2013'}</p>
              </div>
            </div>
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">
              {Icons.close}
            </button>
          </div>

          <div className="p-6 space-y-6">
            {/* Section 1 — Meeting Identity */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Meeting Identity</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Serial No.</label>
                  <input type="number" value={form.serial_number} onChange={e => setForm(f => ({ ...f, serial_number: e.target.value }))} className={ic} placeholder="1" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Type</label>
                  <select value={form.meeting_type} onChange={e => setForm(f => ({ ...f, meeting_type: e.target.value }))} className={ic}>
                    {(llp ? (entity?.meetings?.types || ["Partners' Meeting", 'Meeting by Circulation', 'Adjourned Meeting']) : ['Board Meeting', 'Adjourned Board Meeting', 'Circular Resolution']).map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Number</label>
                  <input value={form.meeting_number} onChange={e => setForm(f => ({ ...f, meeting_number: e.target.value }))} className={ic} placeholder="e.g. 1st Board Meeting" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                  <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                    <option>Scheduled</option>
                    <option>Held</option>
                    <option>Adjourned</option>
                    <option>Cancelled</option>
                    <option>Minutes Pending</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 2 — Date, Time & Venue */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Date, Time & Venue</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Date *</label>
                  <input required type="date" value={form.meeting_date} onChange={e => setForm(f => ({ ...f, meeting_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Day</label>
                  <input value={form.meeting_day} readOnly className={`${ic} bg-gray-50 text-gray-500`} placeholder="Auto-filled" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Time</label>
                  <input type="time" value={form.meeting_time} onChange={e => setForm(f => ({ ...f, meeting_time: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Mode</label>
                  <select value={form.mode} onChange={e => setForm(f => ({ ...f, mode: e.target.value }))} className={ic}>
                    <option>Physical</option>
                    <option>Video Conferencing</option>
                    <option>Hybrid</option>
                  </select>
                </div>
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Venue / Link</label>
                  <input value={form.venue} onChange={e => setForm(f => ({ ...f, venue: e.target.value }))} className={ic} placeholder="Registered office address or VC link" />
                </div>
              </div>
            </div>

            {/* Section 3 — Notice */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Notice Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Notice Date</label>
                  <input type="date" value={form.notice_date} onChange={e => setForm(f => ({ ...f, notice_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Notice Mode</label>
                  <select value={form.notice_mode} onChange={e => setForm(f => ({ ...f, notice_mode: e.target.value }))} className={ic}>
                    <option>Email</option>
                    <option>Physical</option>
                    <option>Both</option>
                    <option>Hand Delivery</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 4 — Quorum / attendance */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">{llp ? 'Attendance' : 'Quorum & Attendance'}</p>
              <div className="grid grid-cols-4 gap-4">
                {!llp && (
                  <>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Total Board Strength</label>
                      <input type="number" value={form.total_strength} onChange={e => setForm(f => ({ ...f, total_strength: e.target.value }))} className={ic} />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Quorum Required</label>
                      <input type="number" value={form.quorum_required} onChange={e => setForm(f => ({ ...f, quorum_required: e.target.value }))} className={ic} />
                    </div>
                  </>
                )}
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">{llp ? 'Quorum met (per Agreement)' : 'Quorum Present'}</label>
                  <select value={form.quorum_present ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, quorum_present: e.target.value === 'yes' }))} className={ic}>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">{llp ? 'Chairperson' : 'Chairman'}</label>
                  <input value={form.chairman} onChange={e => setForm(f => ({ ...f, chairman: e.target.value }))} className={ic} placeholder="Name" />
                </div>
                {!llp && (
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">Company Secretary</label>
                    <input value={form.company_secretary} onChange={e => setForm(f => ({ ...f, company_secretary: e.target.value }))} className={ic} />
                  </div>
                )}
              </div>
            </div>

            {/* Section 5 — MGT-14 (company only) */}
            {!llp && (
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">MGT-14 Filing</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">MGT-14 Required</label>
                  <select value={form.mgt14_required ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, mgt14_required: e.target.value === 'yes' }))} className={ic}>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                </div>
                {form.mgt14_required && (
                  <>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">MGT-14 SRN</label>
                      <input value={form.mgt14_srn} onChange={e => setForm(f => ({ ...f, mgt14_srn: e.target.value.toUpperCase() }))} className={ic} placeholder="SRN" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Filing Date</label>
                      <input type="date" value={form.mgt14_filed_date} onChange={e => setForm(f => ({ ...f, mgt14_filed_date: e.target.value }))} className={ic} />
                    </div>
                  </>
                )}
              </div>
            </div>
            )}

            {/* Section 6 — Minutes */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Minutes</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Minutes Signed Date</label>
                  <input type="date" value={form.minutes_signed_date} onChange={e => setForm(f => ({ ...f, minutes_signed_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Signed By</label>
                  <input value={form.minutes_signed_by} onChange={e => setForm(f => ({ ...f, minutes_signed_by: e.target.value }))} className={ic} placeholder="Chairman / Director" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Next Meeting Date</label>
                  <input type="date" value={form.next_meeting_date} onChange={e => setForm(f => ({ ...f, next_meeting_date: e.target.value }))} className={ic} />
                </div>
              </div>
            </div>

            {/* Notes */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
              <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} className={ic} placeholder="Internal notes" />
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium hover:bg-white transition">
              Cancel
            </button>
            <button type="submit" disabled={saving}
              className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-60 transition shadow-sm"
              style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : editingId ? 'Update Meeting' : 'Save Meeting'}
            </button>
          </div>
        </form>
      )}

      {/* Meetings List */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>Meeting Records</p>
          <p className="text-xs text-gray-400 mt-0.5">{meetings.length} meetings recorded</p>
        </div>

        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading meetings...</div>
        ) : meetings.length === 0 ? (
          <div className="py-16 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#eff6ff' }}>
              <span style={{ color: '#00206E' }}>{Icons.boardMeeting}</span>
            </div>
            <p className="text-sm font-semibold text-gray-500">{llp ? "No partners' meetings recorded" : 'No board meetings recorded'}</p>
            <p className="text-xs text-gray-400 mt-1">{llp ? "Record your first partners' meeting above" : 'Record your first board meeting above'}</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Sr.', 'Meeting', 'Date & Day', 'Mode / Venue', 'Quorum', llp ? 'Chairperson' : 'Chairman', ...(llp ? [] : ['MGT-14']), 'Minutes', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {meetings.map(m => (
                  <tr key={m.id} className="border-b border-gray-50 hover:bg-gray-50 transition">
                    <td className="px-4 py-3 text-xs font-mono text-gray-400">{m.serial_number || '-'}</td>
                    <td className="px-4 py-3">
                      <button onClick={() => setSelectedMeeting(m)} className="text-left hover:underline" style={{ color: '#00206E' }}>
                        <p className="text-sm font-semibold">{m.meeting_number || m.meeting_type}</p>
                        <p className="text-xs text-gray-400">{m.meeting_type}</p>
                      </button>
                    </td>
                    <td className="px-4 py-3">
                      <p className="text-sm font-medium text-gray-800">
                        {m.meeting_date ? new Date(m.meeting_date).toLocaleDateString('en-IN') : '-'}
                      </p>
                      <p className="text-xs text-gray-400">{m.meeting_day || '-'}{m.meeting_time ? ` · ${m.meeting_time}` : ''}</p>
                    </td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#eff6ff', color: '#00206E', borderColor: '#bfdbfe' }}>
                        {m.mode}
                      </span>
                      {m.venue && <p className="text-xs text-gray-400 mt-1 max-w-32 truncate">{m.venue}</p>}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        m.quorum_present
                          ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
                          : 'bg-red-50 text-red-600 border-red-100'
                      }`}>
                        {m.quorum_present ? '✓ Present' : '✗ Absent'}
                      </span>
                      {m.total_strength > 0 && (
                        <p className="text-xs text-gray-400 mt-0.5">
                          Req: {m.quorum_required}/{m.total_strength}
                        </p>
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{m.chairman || '-'}</td>
                    {!llp && (
                      <td className="px-4 py-3">
                        {m.mgt14_required ? (
                          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                            m.mgt14_srn
                              ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
                              : 'bg-amber-50 text-amber-700 border-amber-100'
                          }`}>
                            {m.mgt14_srn ? '✓ Filed' : 'Pending'}
                          </span>
                        ) : (
                          <span className="text-xs text-gray-400">N/A</span>
                        )}
                      </td>
                    )}
                    <td className="px-4 py-3">
                      {m.minutes_signed_date ? (
                        <p className="text-xs font-semibold text-emerald-600">
                          ✓ {new Date(m.minutes_signed_date).toLocaleDateString('en-IN')}
                        </p>
                      ) : (
                        <span className="text-xs text-amber-600 font-semibold">Pending</span>
                      )}
                    </td>
                    <td className="px-4 py-3"><StatusBadge status={m.status} /></td>
                    <td className="px-4 py-3 relative" data-kebab>
                      <button
                        onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === m.id ? null : m.id); }}
                        className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center transition"
                        data-kebab
                      >
                        {Icons.kebab}
                      </button>
                      {openMenuId === m.id && (
                        <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-44 p-1.5" data-kebab>
                          <button onClick={() => { setSelectedMeeting(m); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition" style={{ color: '#00206E' }}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                            View Details
                          </button>
                          <button onClick={() => { handleEdit(m); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 transition">
                            {Icons.edit} Edit
                          </button>
                          <div className="border-t border-gray-100 my-1" />
                          <button onClick={() => { handleDelete(m); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50 transition">
                            {Icons.delete} Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── MEETING DETAIL VIEW ─────────────────────────────────────────────────────
function MeetingDetail({ meeting, company, entity, onBack, headers }) {
  const llp = !!entity?.isLLP;
  const [attendance, setAttendance] = useState([]);
  const [agendas, setAgendas] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');
  const [directors, setDirectors] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [attRes, agRes, dirRes] = await Promise.all([
          fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/attendance`, { headers }),
          fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/agendas`, { headers }),
          fetch(`${BASE}/api/mca/companies/${company.id}/directors`, { headers }),
        ]);
        setAttendance(await attRes.json().catch(() => []));
        setAgendas(await agRes.json().catch(() => []));
        setDirectors(await dirRes.json().catch(() => []));
      } catch (e) { console.error(e); }
    };
    fetchAll();
  }, [meeting.id, company.id]);

  const TABS = [
    { key: 'overview', label: 'Overview' },
    { key: 'attendance', label: `Attendance (${attendance.length})` },
    { key: 'agenda', label: `Agenda (${agendas.length})` },
    { key: 'documents', label: 'Documents' },
  ];

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={onBack}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">
            {Icons.back}
          </button>
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">
              {meeting.meeting_number || meeting.meeting_type}
            </p>
            <p className="text-xs text-gray-400 mt-0.5">
              {company.company_name} · {meeting.meeting_date ? new Date(meeting.meeting_date).toLocaleDateString('en-IN') : '-'}
              {meeting.meeting_day ? ` · ${meeting.meeting_day}` : ''}
            </p>
          </div>
        </div>
        <StatusBadge status={meeting.status} />
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="border-b border-gray-100 px-6 flex items-center gap-1">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className="px-4 py-3.5 text-sm font-medium border-b-2 transition-colors"
              style={{
                borderColor: activeTab === tab.key ? '#00206E' : 'transparent',
                color: activeTab === tab.key ? '#00206E' : '#9ca3af',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Overview */}
        {activeTab === 'overview' && (
          <div className="p-6 grid grid-cols-2 gap-6">
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Meeting Details</p>
              {[
                { label: 'Meeting Type', value: meeting.meeting_type },
                { label: 'Date', value: meeting.meeting_date ? new Date(meeting.meeting_date).toLocaleDateString('en-IN') : '-' },
                { label: 'Day', value: meeting.meeting_day || '-' },
                { label: 'Time', value: meeting.meeting_time || '-' },
                { label: 'Mode', value: meeting.mode || '-' },
                { label: 'Venue', value: meeting.venue || '-' },
              ].map(r => (
                <div key={r.label} className="flex justify-between py-2 border-b border-gray-50">
                  <span className="text-xs text-gray-400">{r.label}</span>
                  <span className="text-xs font-semibold text-gray-700 text-right max-w-48 truncate">{r.value}</span>
                </div>
              ))}
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">{llp ? 'Details' : 'Compliance'}</p>
              {[
                { label: 'Notice Date', value: meeting.notice_date ? new Date(meeting.notice_date).toLocaleDateString('en-IN') : '-' },
                { label: 'Notice Mode', value: meeting.notice_mode || '-' },
                ...(llp ? [] : [
                  { label: 'Total Strength', value: meeting.total_strength || '-' },
                  { label: 'Quorum Required', value: meeting.quorum_required || '-' },
                ]),
                { label: llp ? 'Chairperson' : 'Chairman', value: meeting.chairman || '-' },
                ...(llp ? [] : [
                  { label: 'Company Secretary', value: meeting.company_secretary || '-' },
                  { label: 'MGT-14 Required', value: meeting.mgt14_required ? 'Yes' : 'No' },
                  { label: 'MGT-14 SRN', value: meeting.mgt14_srn || '-' },
                ]),
                { label: 'Minutes Signed', value: meeting.minutes_signed_date ? new Date(meeting.minutes_signed_date).toLocaleDateString('en-IN') : 'Pending' },
                { label: 'Next Meeting', value: meeting.next_meeting_date ? new Date(meeting.next_meeting_date).toLocaleDateString('en-IN') : '-' },
              ].map(r => (
                <div key={r.label} className="flex justify-between py-2 border-b border-gray-50">
                  <span className="text-xs text-gray-400">{r.label}</span>
                  <span className="text-xs font-semibold text-gray-700">{r.value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Attendance */}
        {activeTab === 'attendance' && (
          <AttendanceTab
            meeting={meeting}
            company={company}
            attendance={attendance}
            setAttendance={setAttendance}
            directors={directors}
            headers={headers}
          />
        )}

        {/* Agenda */}
        {activeTab === 'agenda' && (
          <AgendaTab
            meeting={meeting}
            company={company}
            entity={entity}
            agendas={agendas}
            setAgendas={setAgendas}
            headers={headers}
          />
        )}

        {/* Documents */}
        {activeTab === 'documents' && (
          <MeetingDocumentsTab meeting={meeting} type="BM" companyName={company.company_name} headers={headers} />
        )}
      </div>
    </div>
  );
}

// ── DOCUMENTS TAB — Notice / Shorter Consent / Minutes / Attendance
// Sheet / CTC, generated from the SAME data and SAME builders the Event
// Filing module uses (documentGenerators.js), pulled via
// GET /api/mca/meetings/:id/documents-data using the link this register
// entry was created with (event_filing_meeting_id). Only meetings that
// were synced FROM an Event Filing case have that link — meetings
// recorded directly in this register have no linked case to pull an
// agenda, votes or resolution text from, so no documents to generate.
// ────────────────────────────────────────────────────────────────────────
function MeetingDocumentsTab({ meeting, type, companyName, headers }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shorterConsent, setShorterConsent] = useState(null);
  const [ctcSelection, setCtcSelection] = useState({});
  const [extras, setExtras] = useState({});

  const linkedId = meeting.event_filing_meeting_id;

  useEffect(() => {
    if (!linkedId) { setLoading(false); return; }
    setLoading(true);
    fetch(`${BASE}/api/mca/meetings/${linkedId}/documents-data`, { headers })
      .then(r => r.json())
      .then(d => {
        setData(d);
        setExtras(d.meeting?.document_extras || {});
        if (d.meeting?.document_extras?.shorter_consent) setShorterConsent(d.meeting.document_extras.shorter_consent);
      })
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [linkedId]);

  if (!linkedId) {
    return (
      <div className="p-10 text-center text-gray-400 text-sm">
        This meeting wasn't synced from an Event Filing case, so there's no linked agenda/resolutions to generate documents from.
        <br />Documents generated from Event Filings' Documents tab will appear here automatically once synced.
      </div>
    );
  }
  if (loading) return <div className="p-10 text-center text-gray-400 text-sm">Loading…</div>;
  if (!data) return <div className="p-10 text-center text-gray-400 text-sm">Could not load the linked meeting data.</div>;

  const md = { ...data.meeting, notice_date: data.meeting.document_extras?.notice_date, venue_mode: data.meeting.document_extras?.venue_mode };
  const items = buildAgendaItems(data.cases, data.meeting.id);
  const directors = data.directors || [];
  const shareholders = data.shareholders || [];
  const companyType = data.company?.company_type || '';
  const isBM = type === 'BM';
  const attendees = md.attendees || [];
  const consentRoster = isBM ? directors.map(d => d.director_name) : shareholders.map(s => s.member_name);
  const consenters = shorterConsent || attendees;
  const gapDays = noticeGapDays(type, md.notice_date, md.meeting_date);
  const requiredDays = requiredNoticeDays(type);
  const isShort = gapDays !== null && gapDays < requiredDays;
  const selectedCount = items.filter(i => ctcSelection[i.itemNo]).length;

  const toggleConsent = (name) => setShorterConsent(prev => {
    const current = prev || attendees;
    return current.includes(name) ? current.filter(n => n !== name) : [...current, name];
  });

  return (
    <div className="p-5 space-y-4">
      <div>
        <p className="text-xs font-semibold text-gray-600 mb-2">Notice & Minutes</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => downloadWord(`Notice ${type} - ${companyName}`, buildNoticeHtml({ companyName, type, md, items, shorter: !!extras.shorter_notice, serial: meeting.serial_number }))}
            className="px-3 py-2 rounded-lg border border-gray-200 text-gray-600 text-xs font-semibold">📄 Notice of Meeting (Word)</button>
          <button onClick={() => downloadWord(`Minutes ${type} - ${companyName}`, buildMinutesHtml({ companyName, type, md, items, directors, shareholders, companyType, extras, serial: meeting.serial_number }))}
            className="px-3 py-2 rounded-lg border border-gray-200 text-gray-600 text-xs font-semibold">📄 Minutes (Word)</button>
          <button onClick={() => downloadWord(`Attendance Sheet ${type} - ${companyName}`, buildAttendanceHtml({ companyName, type, md, directors, shareholders }))}
            className="px-3 py-2 rounded-lg border border-gray-200 text-gray-600 text-xs font-semibold">📄 Attendance Sheet (Word)</button>
        </div>
      </div>

      {isShort && (
        <div className="pt-4 border-t border-gray-100">
          <p className="text-xs font-semibold text-gray-600 mb-1">Shorter Notice Consent <span className="font-normal" style={{ color: '#d97706' }}>— only {gapDays} of {requiredDays}{type !== 'BM' ? ' clear' : ''} days given</span></p>
          <div className="flex flex-wrap gap-1.5 mb-3">
            {consentRoster.map(name => (
              <label key={name} className="flex items-center gap-1.5 text-[11px] px-2 py-1 rounded-lg bg-gray-50">
                <input type="checkbox" checked={consenters.includes(name)} onChange={() => toggleConsent(name)} />
                {name}
              </label>
            ))}
            {consentRoster.length === 0 && <p className="text-[11px] text-gray-400">No roster on record.</p>}
          </div>
          <button onClick={() => downloadWord(`Shorter Notice Consent ${type} - ${companyName}`, buildShorterConsentHtml({ companyName, type, md, directors, shareholders, consenters }))}
            className="px-3 py-2 rounded-lg border border-gray-200 text-gray-600 text-xs font-semibold">📄 Shorter Notice Consent (Word)</button>
        </div>
      )}

      <div className="pt-4 border-t border-gray-100">
        <p className="text-xs font-semibold text-gray-600 mb-2">Certified True Copy (CTC)</p>
        {items.length > 1 && (
          <div className="space-y-1 mb-3 border border-gray-100 rounded-lg divide-y divide-gray-50">
            {items.map(i => (
              <label key={i.itemNo} className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-50">
                <input type="checkbox" checked={!!ctcSelection[i.itemNo]} onChange={() => setCtcSelection(prev => ({ ...prev, [i.itemNo]: !prev[i.itemNo] }))} />
                <span className="font-semibold text-gray-400">#{i.itemNo}</span> {i.resolution.resolution_title}
              </label>
            ))}
          </div>
        )}
        <div className="flex flex-wrap gap-2">
          <button onClick={() => downloadWord(`CTC ${type} - ${companyName}`, buildCtcHtml({ companyName, type, md, chosen: items, extras }))}
            className="px-3 py-2 rounded-lg text-white text-xs font-semibold" style={{ background: '#00206E' }}>📄 Full CTC — All Resolutions</button>
          {items.length > 1 && (
            <button onClick={() => downloadWord(`CTC ${type} - ${companyName}`, buildCtcHtml({ companyName, type, md, chosen: items.filter(i => ctcSelection[i.itemNo]), extras }))}
              disabled={selectedCount === 0}
              className="px-3 py-2 rounded-lg border border-gray-200 text-gray-600 text-xs font-semibold disabled:opacity-40">📄 CTC — Selected ({selectedCount})</button>
          )}
        </div>
      </div>
    </div>
  );
}

// ── ATTENDANCE TAB ──────────────────────────────────────────────────────────
function AttendanceTab({ meeting, company, attendance, setAttendance, directors, headers }) {
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const EMPTY = { director_id: '', director_name: '', din: '', designation: '', attended: true, leave_of_absence: false, mode_of_attendance: 'Physical', notes: '' };
  const [form, setForm] = useState(EMPTY);

  const handlePersonSelect = pid => {
    const d = directors.find(x => String(x.id) === String(pid));
    if (!d) return;
    setForm(f => ({ ...f, director_id: d.id, director_name: d.director_name, din: d.din || '', designation: d.designation || '' }));
  };

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/attendance`, {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      setAttendance(prev => [...prev, data]);
      setForm(EMPTY); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Remove attendance record?')) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/attendance/${id}`, { method: 'DELETE', headers });
    setAttendance(prev => prev.filter(a => a.id !== id));
  };

  // Auto-import directors
  const handleImportAll = async () => {
    if (directors.length === 0) { alert('No directors found for this company'); return; }
    setSaving(true);
    try {
      const existing = new Set(attendance.map(a => a.director_id));
      for (const d of directors.filter(d => d.is_active && !existing.has(d.id))) {
        const res = await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/attendance`, {
          method: 'POST',
          headers: { ...headers, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            director_id: d.id,
            director_name: d.director_name,
            din: d.din || '',
            designation: d.designation || '',
            attended: true,
            mode_of_attendance: 'Physical',
          }),
        });
        const data = await res.json();
        if (res.ok) setAttendance(prev => [...prev, data]);
      }
    } catch (e) { alert('Error importing'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
        <div>
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>Attendance Register</p>
          <p className="text-xs text-gray-400 mt-0.5">
            {attendance.filter(a => a.attended).length} present · {attendance.filter(a => !a.attended).length} absent
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={handleImportAll} disabled={saving}
            className="flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-semibold transition disabled:opacity-50"
            style={{ borderColor: '#00206E', color: '#00206E' }}>
            Import Directors
          </button>
          <button onClick={() => { setForm(EMPTY); setShowForm(true); }}
            className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-xs font-semibold shadow-sm"
            style={{ background: '#00206E' }}>
            {Icons.add} Add
          </button>
        </div>
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="px-6 py-4 border-b border-gray-100 bg-gray-50">
          <div className="grid grid-cols-4 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Link Director</label>
              <select value={form.director_id} onChange={e => handlePersonSelect(e.target.value)} className={ic}>
                <option value="">Select director</option>
                {directors.map(d => <option key={d.id} value={d.id}>{d.director_name}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Name *</label>
              <input required value={form.director_name} onChange={e => setForm(f => ({ ...f, director_name: e.target.value }))} className={ic} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">DIN</label>
              <input value={form.din} onChange={e => setForm(f => ({ ...f, din: e.target.value }))} className={ic} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Mode</label>
              <select value={form.mode_of_attendance} onChange={e => setForm(f => ({ ...f, mode_of_attendance: e.target.value }))} className={ic}>
                <option>Physical</option>
                <option>Video Conferencing</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Attended</label>
              <select value={form.attended ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, attended: e.target.value === 'yes' }))} className={ic}>
                <option value="yes">Present</option>
                <option value="no">Absent</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Leave of Absence</label>
              <select value={form.leave_of_absence ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, leave_of_absence: e.target.value === 'yes' }))} className={ic}>
                <option value="no">No</option>
                <option value="yes">Yes (Granted)</option>
              </select>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-3">
            <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 rounded-xl border border-gray-200 text-gray-600 text-xs font-medium hover:bg-white">Cancel</button>
            <button type="submit" disabled={saving} className="px-5 py-2 rounded-xl text-white text-xs font-semibold disabled:opacity-60" style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      )}

      {attendance.length === 0 ? (
        <div className="py-10 text-center text-gray-400 text-sm">No attendance recorded yet</div>
      ) : (
        <table className="w-full">
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              {['Director', 'DIN', 'Designation', 'Mode', 'Attendance', 'Leave', ''].map(h => (
                <th key={h} className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {attendance.map(a => (
              <tr key={a.id} className="border-b border-gray-50 hover:bg-gray-50">
                <td className="px-5 py-3 text-sm font-semibold text-gray-800">{a.director_name}</td>
                <td className="px-5 py-3 text-sm text-gray-600">{a.din || '-'}</td>
                <td className="px-5 py-3 text-sm text-gray-600">{a.designation || '-'}</td>
                <td className="px-5 py-3 text-xs text-gray-600">{a.mode_of_attendance}</td>
                <td className="px-5 py-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-semibold border ${
                    a.attended ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-red-50 text-red-600 border-red-100'
                  }`}>
                    {a.attended ? 'Present' : 'Absent'}
                  </span>
                </td>
                <td className="px-5 py-3 text-xs text-gray-500">{a.leave_of_absence ? 'Granted' : '-'}</td>
                <td className="px-5 py-3">
                  <button onClick={() => handleDelete(a.id)} className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:bg-red-50 hover:text-red-500 transition">
                    {Icons.delete}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ── AGENDA TAB ──────────────────────────────────────────────────────────────
function AgendaTab({ meeting, company, entity, agendas, setAgendas, headers }) {
  const llp = !!entity?.isLLP;
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const EMPTY = {
    serial_number: '', agenda_title: '', agenda_description: '',
    agenda_type: 'Discussion', resolution_required: false,
    resolution_type: '', resolution_text: '', resolution_passed: null,
    votes_for: 0, votes_against: 0, votes_abstained: 0, mgt14_applicable: false,
  };
  const [form, setForm] = useState(EMPTY);

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/agendas/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/agendas`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      if (editingId) {
        setAgendas(prev => prev.map(a => a.id === editingId ? data : a));
      } else {
        setAgendas(prev => [...prev, data]);
      }
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete agenda item?')) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/board-meetings/${meeting.id}/agendas/${id}`, { method: 'DELETE', headers });
    setAgendas(prev => prev.filter(a => a.id !== id));
  };

  return (
    <div>
      <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
        <div>
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>Agenda & Resolutions</p>
          <p className="text-xs text-gray-400 mt-0.5">{agendas.length} agenda items</p>
        </div>
        <button onClick={() => { setForm({ ...EMPTY, serial_number: agendas.length + 1 }); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-xs font-semibold shadow-sm"
          style={{ background: '#00206E' }}>
          {Icons.add} Add Item
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="px-6 py-5 border-b border-gray-100 bg-gray-50 space-y-4">
          <div className="grid grid-cols-4 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Sr. No.</label>
              <input type="number" value={form.serial_number} onChange={e => setForm(f => ({ ...f, serial_number: e.target.value }))} className={ic} />
            </div>
            <div className="col-span-2">
              <label className="block text-xs font-medium text-gray-600 mb-1">Agenda Title *</label>
              <input required value={form.agenda_title} onChange={e => setForm(f => ({ ...f, agenda_title: e.target.value }))} className={ic} placeholder="e.g. Approval of financial statements" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Type</label>
              <select value={form.agenda_type} onChange={e => setForm(f => ({ ...f, agenda_type: e.target.value }))} className={ic}>
                <option>Discussion</option>
                <option>Resolution</option>
                <option>Noting</option>
                <option>Any Other Business</option>
              </select>
            </div>
            <div className="col-span-4">
              <label className="block text-xs font-medium text-gray-600 mb-1">Description</label>
              <input value={form.agenda_description} onChange={e => setForm(f => ({ ...f, agenda_description: e.target.value }))} className={ic} placeholder="Brief description of agenda item" />
            </div>
          </div>

          <div className="grid grid-cols-4 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Resolution Required</label>
              <select value={form.resolution_required ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, resolution_required: e.target.value === 'yes' }))} className={ic}>
                <option value="no">No</option>
                <option value="yes">Yes</option>
              </select>
            </div>
            {form.resolution_required && (
              <>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">{llp ? 'Decision Mode' : 'Resolution Type'}</label>
                  <select value={form.resolution_type} onChange={e => setForm(f => ({ ...f, resolution_type: e.target.value }))} className={ic}>
                    <option value="">Select</option>
                    {(llp ? (entity?.meetings?.decisionModes || ['By majority of partners', 'Unanimous', 'As per LLP Agreement']) : ['Ordinary Resolution', 'Special Resolution', 'Board Resolution']).map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">{llp ? 'Decision' : 'Resolution Passed'}</label>
                  <select value={form.resolution_passed === null ? '' : form.resolution_passed ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, resolution_passed: e.target.value === '' ? null : e.target.value === 'yes' }))} className={ic}>
                    <option value="">Not decided</option>
                    <option value="yes">{llp ? 'Approved' : 'Passed'}</option>
                    <option value="no">{llp ? 'Not approved' : 'Not Passed'}</option>
                  </select>
                </div>
                {!llp && (
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">MGT-14 Applicable</label>
                    <select value={form.mgt14_applicable ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, mgt14_applicable: e.target.value === 'yes' }))} className={ic}>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                )}
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Resolution Text</label>
                  <textarea rows="3" value={form.resolution_text} onChange={e => setForm(f => ({ ...f, resolution_text: e.target.value }))} className={ic} placeholder="RESOLVED THAT..." />
                </div>
                <div className="grid grid-cols-3 gap-3 col-span-4">
                  {['votes_for', 'votes_against', 'votes_abstained'].map(field => (
                    <div key={field}>
                      <label className="block text-xs font-medium text-gray-600 mb-1">
                        {field === 'votes_for' ? 'Votes For' : field === 'votes_against' ? 'Votes Against' : 'Abstained'}
                      </label>
                      <input type="number" value={form[field]} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))} className={ic} />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }} className="px-4 py-2 rounded-xl border border-gray-200 text-gray-600 text-xs font-medium hover:bg-white">Cancel</button>
            <button type="submit" disabled={saving} className="px-5 py-2 rounded-xl text-white text-xs font-semibold disabled:opacity-60" style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : editingId ? 'Update' : 'Save Item'}
            </button>
          </div>
        </form>
      )}

      {agendas.length === 0 ? (
        <div className="py-10 text-center text-gray-400 text-sm">No agenda items added yet</div>
      ) : (
        <div className="p-5 space-y-3">
          {agendas.map((a, idx) => (
            <div key={a.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden hover:border-blue-100 transition">
              <div className="px-5 py-4 flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 min-w-0">
                  <div className="w-8 h-8 rounded-xl flex items-center justify-center text-xs font-bold text-white flex-shrink-0" style={{ background: '#00206E' }}>
                    {a.serial_number || idx + 1}
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="text-sm font-bold" style={{ color: '#00206E' }}>{a.agenda_title}</p>
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#eff6ff', color: '#00206E', borderColor: '#bfdbfe' }}>
                        {a.agenda_type}
                      </span>
                      {a.resolution_required && (
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${
                          a.resolution_passed === true ? 'bg-emerald-50 text-emerald-700 border-emerald-100' :
                          a.resolution_passed === false ? 'bg-red-50 text-red-600 border-red-100' :
                          'bg-amber-50 text-amber-700 border-amber-100'
                        }`}>
                          {a.resolution_passed === true ? '✓ Passed' : a.resolution_passed === false ? '✗ Not Passed' : 'Pending'}
                        </span>
                      )}
                      {a.mgt14_applicable && (
                        <span className="px-2 py-0.5 rounded-full text-xs font-medium border bg-orange-50 text-orange-700 border-orange-100">
                          MGT-14
                        </span>
                      )}
                    </div>
                    {a.agenda_description && <p className="text-xs text-gray-400 mt-1">{a.agenda_description}</p>}
                    {a.resolution_text && (
                      <p className="text-xs text-gray-500 mt-2 italic border-l-2 pl-3 max-w-2xl" style={{ borderColor: '#00206E' }}>
                        {a.resolution_text.slice(0, 200)}{a.resolution_text.length > 200 ? '...' : ''}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <button onClick={() => { setForm({ ...a, serial_number: a.serial_number || '', resolution_passed: a.resolution_passed }); setEditingId(a.id); setShowForm(true); }}
                    className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:bg-blue-50 hover:text-blue-600 transition">
                    {Icons.edit}
                  </button>
                  <button onClick={() => handleDelete(a.id)}
                    className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:bg-red-50 hover:text-red-500 transition">
                    {Icons.delete}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const REGISTER_TYPES = [
  'Board Meeting Register',
  'Shareholders Meeting Register',
  'Committee Meeting Register',
  'Register of Members',
  'Register of Directors & KMP',
  'Register of Charges',
  'Register of Contracts & Arrangements - AOC-2',
  'Register of Share Certificates',
  'Register of Allotment',
];

// ── GENERAL MEETING REGISTER ────────────────────────────────────────────────
export function GeneralMeetingRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  const EMPTY = {
    serial_number: '', meeting_type: 'AGM', meeting_number: '',
    meeting_date: '', meeting_day: '', meeting_time: '',
    venue: '', mode: 'Physical', notice_date: '', notice_mode: 'Email',
    shorter_notice: false, shorter_notice_consent: '',
    financial_year: '', agm_due_date: '',
    total_members: '', members_present: '', quorum_present: true,
    chairman: '', company_secretary: '',
    mgmt14_srn: '', minutes_signed_date: '', minutes_signed_by: '',
    status: 'Scheduled', notes: '',
  };
  const [form, setForm] = useState(EMPTY);

  const fetchMeetings = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/api/mca/companies/${company.id}/general-meetings`, { headers });
      const data = await res.json();
      setMeetings(Array.isArray(data) ? data : []);
    } catch (e) { setMeetings([]); }
    finally { setLoading(false); }
  }, [company.id]);

  useEffect(() => {
    fetchMeetings();
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [fetchMeetings]);

  useEffect(() => {
    if (form.meeting_date) {
      const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      setForm(f => ({ ...f, meeting_day: days[new Date(form.meeting_date).getDay()] }));
    }
  }, [form.meeting_date]);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/general-meetings/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/general-meetings`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      await fetchMeetings();
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = m => {
    setForm({
      serial_number: m.serial_number || '',
      meeting_type: m.meeting_type || 'AGM',
      meeting_number: m.meeting_number || '',
      meeting_date: m.meeting_date ? String(m.meeting_date).slice(0,10) : '',
      meeting_day: m.meeting_day || '',
      meeting_time: m.meeting_time || '',
      venue: m.venue || '', mode: m.mode || 'Physical',
      notice_date: m.notice_date ? String(m.notice_date).slice(0,10) : '',
      notice_mode: m.notice_mode || 'Email',
      shorter_notice: m.shorter_notice || false,
      shorter_notice_consent: m.shorter_notice_consent || '',
      financial_year: m.financial_year || '',
      agm_due_date: m.agm_due_date ? String(m.agm_due_date).slice(0,10) : '',
      total_members: m.total_members || '',
      members_present: m.members_present || '',
      quorum_present: m.quorum_present !== false,
      chairman: m.chairman || '',
      company_secretary: m.company_secretary || '',
      mgmt14_srn: m.mgmt14_srn || '',
      minutes_signed_date: m.minutes_signed_date ? String(m.minutes_signed_date).slice(0,10) : '',
      minutes_signed_by: m.minutes_signed_by || '',
      status: m.status || 'Scheduled',
      notes: m.notes || '',
    });
    setEditingId(m.id); setShowForm(true);
  };

  const handleDelete = async m => {
    if (!window.confirm(`Delete this ${m.meeting_type} record?`)) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/general-meetings/${m.id}`, { method: 'DELETE', headers });
    await fetchMeetings();
  };

  if (selectedMeeting) {
    return (
      <GeneralMeetingDetail
        meeting={selectedMeeting}
        company={company}
        onBack={() => setSelectedMeeting(null)}
        headers={headers}
      />
    );
  }

  const MEETING_TYPE_COLORS = {
    'AGM': { bg: '#eff6ff', color: '#00206E', border: '#bfdbfe' },
    'EGM': { bg: '#fff7ed', color: '#FF8400', border: '#fed7aa' },
    'Postal Ballot': { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' },
    'NCLT Convened': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  };

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">General Meeting Register</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · SS-2 · Section 101</p>
          </div>
        </div>
        <button onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold shadow-sm"
          style={{ background: '#00206E' }}>
          {Icons.add} Record Meeting
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4">
        {[
          { label: 'Total Meetings', value: meetings.length, color: '#00206E' },
          { label: 'AGM', value: meetings.filter(m => m.meeting_type === 'AGM').length, color: '#059669' },
          { label: 'EGM', value: meetings.filter(m => m.meeting_type === 'EGM').length, color: '#FF8400' },
          { label: 'Postal Ballot', value: meetings.filter(m => m.meeting_type === 'Postal Ballot').length, color: '#7c3aed' },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <p className="text-2xl font-bold" style={{ color: s.color }}>{s.value}</p>
            <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Form */}
      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #f5f3ff, #fff7ed)' }}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-sm" style={{ background: '#7c3aed' }}>
                {Icons.generalMeeting}
              </div>
              <div>
                <p className="text-sm font-bold" style={{ color: '#00206E' }}>{editingId ? 'Edit Meeting' : 'Record General Meeting'}</p>
                <p className="text-xs text-gray-400">As per SS-2 and Section 101 of Companies Act 2013</p>
              </div>
            </div>
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">{Icons.close}</button>
          </div>

          <div className="p-6 space-y-6">
            {/* Identity */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Meeting Identity</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Serial No.</label>
                  <input type="number" value={form.serial_number} onChange={e => setForm(f => ({ ...f, serial_number: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Type *</label>
                  <select value={form.meeting_type} onChange={e => setForm(f => ({ ...f, meeting_type: e.target.value }))} className={ic}>
                    <option>AGM</option>
                    <option>EGM</option>
                    <option>Postal Ballot</option>
                    <option>NCLT Convened</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Number</label>
                  <input value={form.meeting_number} onChange={e => setForm(f => ({ ...f, meeting_number: e.target.value }))} className={ic} placeholder="e.g. 1st AGM" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Financial Year</label>
                  <input value={form.financial_year} onChange={e => setForm(f => ({ ...f, financial_year: e.target.value }))} className={ic} placeholder="e.g. 2024-25" />
                </div>
              </div>
            </div>

            {/* Date, Time & Venue */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Date, Time & Venue</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Date *</label>
                  <input required type="date" value={form.meeting_date} onChange={e => setForm(f => ({ ...f, meeting_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Day</label>
                  <input value={form.meeting_day} readOnly className={`${ic} bg-gray-50 text-gray-500`} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Time</label>
                  <input type="time" value={form.meeting_time} onChange={e => setForm(f => ({ ...f, meeting_time: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Mode</label>
                  <select value={form.mode} onChange={e => setForm(f => ({ ...f, mode: e.target.value }))} className={ic}>
                    <option>Physical</option><option>Video Conferencing</option><option>Hybrid</option>
                  </select>
                </div>
                <div className="col-span-2">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Venue</label>
                  <input value={form.venue} onChange={e => setForm(f => ({ ...f, venue: e.target.value }))} className={ic} placeholder="Venue address" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">AGM Due Date</label>
                  <input type="date" value={form.agm_due_date} onChange={e => setForm(f => ({ ...f, agm_due_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                  <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                    <option>Scheduled</option><option>Held</option>
                    <option>Adjourned</option><option>Cancelled</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Notice */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Notice Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Notice Date</label>
                  <input type="date" value={form.notice_date} onChange={e => setForm(f => ({ ...f, notice_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Notice Mode</label>
                  <select value={form.notice_mode} onChange={e => setForm(f => ({ ...f, notice_mode: e.target.value }))} className={ic}>
                    <option>Email</option><option>Physical</option><option>Both</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Shorter Notice</label>
                  <select value={form.shorter_notice ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, shorter_notice: e.target.value === 'yes' }))} className={ic}>
                    <option value="no">No</option><option value="yes">Yes</option>
                  </select>
                </div>
                {form.shorter_notice && (
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">Consent Details</label>
                    <input value={form.shorter_notice_consent} onChange={e => setForm(f => ({ ...f, shorter_notice_consent: e.target.value }))} className={ic} />
                  </div>
                )}
              </div>
            </div>

            {/* Quorum */}
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Quorum & Attendance</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Total Members</label>
                  <input type="number" value={form.total_members} onChange={e => setForm(f => ({ ...f, total_members: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Members Present</label>
                  <input type="number" value={form.members_present} onChange={e => setForm(f => ({ ...f, members_present: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Quorum Present</label>
                  <select value={form.quorum_present ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, quorum_present: e.target.value === 'yes' }))} className={ic}>
                    <option value="yes">Yes</option><option value="no">No</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Chairman</label>
                  <input value={form.chairman} onChange={e => setForm(f => ({ ...f, chairman: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Company Secretary</label>
                  <input value={form.company_secretary} onChange={e => setForm(f => ({ ...f, company_secretary: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">MGT-14 SRN</label>
                  <input value={form.mgmt14_srn} onChange={e => setForm(f => ({ ...f, mgmt14_srn: e.target.value.toUpperCase() }))} className={ic} placeholder="SRN if MGT-14 filed" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Minutes Signed Date</label>
                  <input type="date" value={form.minutes_signed_date} onChange={e => setForm(f => ({ ...f, minutes_signed_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Minutes Signed By</label>
                  <input value={form.minutes_signed_by} onChange={e => setForm(f => ({ ...f, minutes_signed_by: e.target.value }))} className={ic} />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
              <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} className={ic} placeholder="Internal notes" />
            </div>
          </div>

          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium hover:bg-white transition">Cancel</button>
            <button type="submit" disabled={saving}
              className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-60 shadow-sm"
              style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : editingId ? 'Update Meeting' : 'Save Meeting'}
            </button>
          </div>
        </form>
      )}

      {/* List */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>Meeting Records</p>
          <p className="text-xs text-gray-400 mt-0.5">{meetings.length} meetings recorded</p>
        </div>
        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
        ) : meetings.length === 0 ? (
          <div className="py-16 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#f5f3ff', color: '#7c3aed' }}>{Icons.generalMeeting}</div>
            <p className="text-sm font-semibold text-gray-500">No general meetings recorded</p>
            <p className="text-xs text-gray-400 mt-1">Record your first AGM/EGM above</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Sr.', 'Type', 'Meeting', 'Date & Day', 'FY', 'Members', 'Chairman', 'Minutes', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {meetings.map(m => {
                  const tc = MEETING_TYPE_COLORS[m.meeting_type] || { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb' };
                  return (
                    <tr key={m.id} onClick={() => setSelectedMeeting(m)} className="border-b border-gray-50 hover:bg-gray-50 transition cursor-pointer">
                      <td className="px-4 py-3 text-xs font-mono text-gray-400">{m.serial_number || '-'}</td>
                      <td className="px-4 py-3">
                        <span className="px-2 py-0.5 rounded-full text-xs font-semibold border" style={{ background: tc.bg, color: tc.color, borderColor: tc.border }}>
                          {m.meeting_type}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <p className="text-sm font-semibold text-gray-800">{m.meeting_number || m.meeting_type}</p>
                      </td>
                      <td className="px-4 py-3">
                        <p className="text-sm font-medium text-gray-800">{m.meeting_date ? new Date(m.meeting_date).toLocaleDateString('en-IN') : '-'}</p>
                        <p className="text-xs text-gray-400">{m.meeting_day || ''}{m.meeting_time ? ` · ${m.meeting_time}` : ''}</p>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">{m.financial_year || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {m.members_present || '-'}{m.total_members ? `/${m.total_members}` : ''}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">{m.chairman || '-'}</td>
                      <td className="px-4 py-3">
                        {m.minutes_signed_date
                          ? <p className="text-xs font-semibold text-emerald-600">✓ {new Date(m.minutes_signed_date).toLocaleDateString('en-IN')}</p>
                          : <span className="text-xs text-amber-600 font-semibold">Pending</span>}
                      </td>
                      <td className="px-4 py-3"><StatusBadge status={m.status} /></td>
                      <td className="px-4 py-3 relative" data-kebab onClick={e => e.stopPropagation()}>
                        <button
                          onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === m.id ? null : m.id); }}
                          className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center"
                          data-kebab>
                          {Icons.kebab}
                        </button>
                        {openMenuId === m.id && (
                          <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-44 p-1.5" data-kebab>
                            <button onClick={() => { handleEdit(m); setOpenMenuId(null); }}
                              className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 transition">
                              {Icons.edit} Edit
                            </button>
                            <div className="border-t border-gray-100 my-1" />
                            <button onClick={() => { handleDelete(m); setOpenMenuId(null); }}
                              className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50 transition">
                              {Icons.delete} Delete
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── GENERAL MEETING DETAIL — minimal on purpose: unlike Board Meetings,
// AGM/EGM has no per-member attendance or agenda sub-resource in this
// schema (only aggregate total_members/members_present counts), so there's
// nothing to build an Attendance/Agenda tab out of here. Overview covers
// what's already on the record; Documents links back to the Event Filing
// case that produced this meeting, same as the Board Meeting detail view. ──
function GeneralMeetingDetail({ meeting, company, onBack, headers }) {
  const [activeTab, setActiveTab] = useState('overview');
  const TABS = [
    { key: 'overview', label: 'Overview' },
    { key: 'documents', label: 'Documents' },
  ];

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={onBack}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">
            {Icons.back}
          </button>
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">
              {meeting.meeting_number || meeting.meeting_type}
            </p>
            <p className="text-xs text-gray-400 mt-0.5">
              {company.company_name} · {meeting.meeting_date ? new Date(meeting.meeting_date).toLocaleDateString('en-IN') : '-'}
              {meeting.meeting_day ? ` · ${meeting.meeting_day}` : ''}
            </p>
          </div>
        </div>
        <StatusBadge status={meeting.status} />
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="border-b border-gray-100 px-6 flex items-center gap-1">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className="px-4 py-3.5 text-sm font-medium border-b-2 transition-colors"
              style={{
                borderColor: activeTab === tab.key ? '#00206E' : 'transparent',
                color: activeTab === tab.key ? '#00206E' : '#9ca3af',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'overview' && (
          <div className="p-6 grid grid-cols-2 gap-6">
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Meeting Details</p>
              {[
                { label: 'Meeting Type', value: meeting.meeting_type },
                { label: 'Date', value: meeting.meeting_date ? new Date(meeting.meeting_date).toLocaleDateString('en-IN') : '-' },
                { label: 'Day', value: meeting.meeting_day || '-' },
                { label: 'Time', value: meeting.meeting_time || '-' },
                { label: 'Mode', value: meeting.mode || '-' },
                { label: 'Venue', value: meeting.venue || '-' },
                { label: 'Financial Year', value: meeting.financial_year || '-' },
              ].map(r => (
                <div key={r.label} className="flex justify-between py-2 border-b border-gray-50">
                  <span className="text-xs text-gray-400">{r.label}</span>
                  <span className="text-xs font-semibold text-gray-700 text-right max-w-48 truncate">{r.value}</span>
                </div>
              ))}
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Compliance</p>
              {[
                { label: 'Notice Date', value: meeting.notice_date ? new Date(meeting.notice_date).toLocaleDateString('en-IN') : '-' },
                { label: 'Notice Mode', value: meeting.notice_mode || '-' },
                { label: 'Shorter Notice', value: meeting.shorter_notice ? 'Yes' : 'No' },
                { label: 'Total Members', value: meeting.total_members ?? '-' },
                { label: 'Members Present', value: meeting.members_present ?? '-' },
                { label: 'Quorum Present', value: meeting.quorum_present ? 'Yes' : 'No' },
                { label: 'Chairman', value: meeting.chairman || '-' },
                { label: 'Company Secretary', value: meeting.company_secretary || '-' },
                { label: 'MGT-14 SRN', value: meeting.mgmt14_srn || '-' },
                { label: 'Minutes Signed', value: meeting.minutes_signed_date ? new Date(meeting.minutes_signed_date).toLocaleDateString('en-IN') : 'Pending' },
              ].map(r => (
                <div key={r.label} className="flex justify-between py-2 border-b border-gray-50">
                  <span className="text-xs text-gray-400">{r.label}</span>
                  <span className="text-xs font-semibold text-gray-700">{r.value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'documents' && (
          <MeetingDocumentsTab meeting={meeting} type={meeting.meeting_type === 'EGM' ? 'EGM' : 'AGM'} companyName={company.company_name} headers={headers} />
        )}
      </div>
    </div>
  );
}

// ── COMMITTEE MEETING REGISTER ──────────────────────────────────────────────
export function CommitteeMeetingRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);

  const EMPTY = {
    committee_type: 'Audit Committee', serial_number: '',
    meeting_date: '', meeting_time: '', venue: '', mode: 'Physical',
    notice_date: '', members_present: '', quorum_present: true,
    chairman: '', minutes_signed_date: '', minutes_signed_by: '',
    status: 'Scheduled', notes: '',
  };
  const [form, setForm] = useState(EMPTY);

  const fetchMeetings = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/api/mca/companies/${company.id}/committee-meetings`, { headers });
      setMeetings(Array.isArray(await res.json()) ? await res.clone().json() : []);
    } catch (e) { setMeetings([]); }
    finally { setLoading(false); }
  }, [company.id]);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies/${company.id}/committee-meetings`, { headers })
      .then(r => r.json()).then(d => setMeetings(Array.isArray(d) ? d : [])).catch(() => setMeetings([])).finally(() => setLoading(false));
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [company.id]);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/committee-meetings/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/committee-meetings`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      const updated = await fetch(`${BASE}/api/mca/companies/${company.id}/committee-meetings`, { headers }).then(r => r.json());
      setMeetings(Array.isArray(updated) ? updated : []);
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = m => {
    setForm({
      committee_type: m.committee_type || 'Audit Committee',
      serial_number: m.serial_number || '',
      meeting_date: m.meeting_date ? String(m.meeting_date).slice(0,10) : '',
      meeting_time: m.meeting_time || '',
      venue: m.venue || '', mode: m.mode || 'Physical',
      notice_date: m.notice_date ? String(m.notice_date).slice(0,10) : '',
      members_present: m.members_present || '',
      quorum_present: m.quorum_present !== false,
      chairman: m.chairman || '',
      minutes_signed_date: m.minutes_signed_date ? String(m.minutes_signed_date).slice(0,10) : '',
      minutes_signed_by: m.minutes_signed_by || '',
      status: m.status || 'Scheduled', notes: m.notes || '',
    });
    setEditingId(m.id); setShowForm(true);
  };

  const handleDelete = async m => {
    if (!window.confirm('Delete this committee meeting?')) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/committee-meetings/${m.id}`, { method: 'DELETE', headers });
    setMeetings(prev => prev.filter(x => x.id !== m.id));
  };

  const COMMITTEE_COLORS = {
    'Audit Committee': { bg: '#eff6ff', color: '#00206E', border: '#bfdbfe' },
    'NRC': { bg: '#ecfdf5', color: '#059669', border: '#a7f3d0' },
    'CSR Committee': { bg: '#fff7ed', color: '#FF8400', border: '#fed7aa' },
    'Risk Management': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
    'Stakeholder Committee': { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' },
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Committee Meeting Register</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · Section 177 & 178</p>
          </div>
        </div>
        <button onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold shadow-sm"
          style={{ background: '#00206E' }}>
          {Icons.add} Record Meeting
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-5 gap-3">
        {['Audit Committee','NRC','CSR Committee','Risk Management','Stakeholder Committee'].map(ct => (
          <div key={ct} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3 text-center">
            <p className="text-xl font-bold" style={{ color: (COMMITTEE_COLORS[ct] || {}).color || '#00206E' }}>
              {meetings.filter(m => m.committee_type === ct).length}
            </p>
            <p className="text-xs text-gray-400 mt-1 leading-tight">{ct}</p>
          </div>
        ))}
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #ecfeff, #eff6ff)' }}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-sm" style={{ background: '#0891b2' }}>{Icons.committee}</div>
              <div>
                <p className="text-sm font-bold" style={{ color: '#00206E' }}>{editingId ? 'Edit Meeting' : 'Record Committee Meeting'}</p>
                <p className="text-xs text-gray-400">Section 177 & 178 of Companies Act 2013</p>
              </div>
            </div>
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">{Icons.close}</button>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-4 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Committee Type *</label>
                <select value={form.committee_type} onChange={e => setForm(f => ({ ...f, committee_type: e.target.value }))} className={ic}>
                  <option>Audit Committee</option>
                  <option>NRC</option>
                  <option>CSR Committee</option>
                  <option>Risk Management</option>
                  <option>Stakeholder Committee</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Serial No.</label>
                <input type="number" value={form.serial_number} onChange={e => setForm(f => ({ ...f, serial_number: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Meeting Date *</label>
                <input required type="date" value={form.meeting_date} onChange={e => setForm(f => ({ ...f, meeting_date: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Time</label>
                <input type="time" value={form.meeting_time} onChange={e => setForm(f => ({ ...f, meeting_time: e.target.value }))} className={ic} />
              </div>
              <div className="col-span-2">
                <label className="block text-xs font-medium text-gray-600 mb-1">Venue</label>
                <input value={form.venue} onChange={e => setForm(f => ({ ...f, venue: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Mode</label>
                <select value={form.mode} onChange={e => setForm(f => ({ ...f, mode: e.target.value }))} className={ic}>
                  <option>Physical</option><option>Video Conferencing</option><option>Hybrid</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Notice Date</label>
                <input type="date" value={form.notice_date} onChange={e => setForm(f => ({ ...f, notice_date: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Members Present</label>
                <input type="number" value={form.members_present} onChange={e => setForm(f => ({ ...f, members_present: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Quorum Present</label>
                <select value={form.quorum_present ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, quorum_present: e.target.value === 'yes' }))} className={ic}>
                  <option value="yes">Yes</option><option value="no">No</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Chairman</label>
                <input value={form.chairman} onChange={e => setForm(f => ({ ...f, chairman: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Minutes Signed Date</label>
                <input type="date" value={form.minutes_signed_date} onChange={e => setForm(f => ({ ...f, minutes_signed_date: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Minutes Signed By</label>
                <input value={form.minutes_signed_by} onChange={e => setForm(f => ({ ...f, minutes_signed_by: e.target.value }))} className={ic} />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                  <option>Scheduled</option><option>Held</option><option>Adjourned</option><option>Cancelled</option>
                </select>
              </div>
              <div className="col-span-4">
                <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
                <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} className={ic} placeholder="Internal notes" />
              </div>
            </div>
          </div>
          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium hover:bg-white transition">Cancel</button>
            <button type="submit" disabled={saving}
              className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-60 shadow-sm"
              style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : editingId ? 'Update' : 'Save Meeting'}
            </button>
          </div>
        </form>
      )}

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>Meeting Records</p>
          <p className="text-xs text-gray-400">{meetings.length} meetings recorded</p>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading...</div>
        ) : meetings.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#ecfeff', color: '#0891b2' }}>{Icons.committee}</div>
            <p className="text-sm font-semibold text-gray-500">No committee meetings recorded</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Sr.', 'Committee', 'Date', 'Mode', 'Members', 'Chairman', 'Minutes', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {meetings.map(m => {
                  const cc = COMMITTEE_COLORS[m.committee_type] || { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb' };
                  return (
                    <tr key={m.id} className="border-b border-gray-50 hover:bg-gray-50 transition">
                      <td className="px-4 py-3 text-xs font-mono text-gray-400">{m.serial_number || '-'}</td>
                      <td className="px-4 py-3">
                        <span className="px-2 py-0.5 rounded-full text-xs font-semibold border" style={{ background: cc.bg, color: cc.color, borderColor: cc.border }}>
                          {m.committee_type}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <p className="text-sm font-medium text-gray-800">{m.meeting_date ? new Date(m.meeting_date).toLocaleDateString('en-IN') : '-'}</p>
                        {m.meeting_time && <p className="text-xs text-gray-400">{m.meeting_time}</p>}
                      </td>
                      <td className="px-4 py-3 text-xs text-gray-600">{m.mode}</td>
                      <td className="px-4 py-3 text-sm text-gray-600">{m.members_present || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-600">{m.chairman || '-'}</td>
                      <td className="px-4 py-3">
                        {m.minutes_signed_date
                          ? <p className="text-xs font-semibold text-emerald-600">✓ {new Date(m.minutes_signed_date).toLocaleDateString('en-IN')}</p>
                          : <span className="text-xs text-amber-600 font-semibold">Pending</span>}
                      </td>
                      <td className="px-4 py-3"><StatusBadge status={m.status} /></td>
                      <td className="px-4 py-3 relative" data-kebab>
                        <button onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === m.id ? null : m.id); }}
                          className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center" data-kebab>
                          {Icons.kebab}
                        </button>
                        {openMenuId === m.id && (
                          <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-44 p-1.5" data-kebab>
                            <button onClick={() => { handleEdit(m); setOpenMenuId(null); }}
                              className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">{Icons.edit} Edit</button>
                            <div className="border-t border-gray-100 my-1" />
                            <button onClick={() => { handleDelete(m); setOpenMenuId(null); }}
                              className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50">{Icons.delete} Delete</button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── REGISTER OF MEMBERS ─────────────────────────────────────────────────────
function MembersRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [shareholders, setShareholders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies/${company.id}/shareholders`, { headers })
      .then(r => r.json()).then(d => setShareholders(Array.isArray(d) ? d : [])).catch(() => setShareholders([])).finally(() => setLoading(false));
  }, [company.id]);

  const active = shareholders.filter(s => s.is_active);
  const ceased = shareholders.filter(s => !s.is_active);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Register of Members</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · MGT-1 Format · Section 88</p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <span className="px-3 py-1.5 rounded-xl border border-gray-200 font-medium">
            Managed from Company Master → Shareholding tab
          </span>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4">
        {[
          { label: 'Total Members', value: shareholders.length, color: '#00206E' },
          { label: 'Active Members', value: active.length, color: '#059669' },
          { label: 'Ceased Members', value: ceased.length, color: '#dc2626' },
          { label: 'Total Shares', value: active.reduce((sum, s) => sum + (Number(s.no_of_shares) || 0), 0).toLocaleString('en-IN'), color: '#FF8400' },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <p className="text-2xl font-bold" style={{ color: s.color }}>{loading ? '—' : s.value}</p>
            <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>MGT-1 — Register of Members</p>
          <span className="px-3 py-1 rounded-xl text-xs font-semibold" style={{ background: '#eff6ff', color: '#00206E' }}>
            Section 88 · Companies Act 2013
          </span>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading register...</div>
        ) : shareholders.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#ecfdf5', color: '#059669' }}>{Icons.members}</div>
            <p className="text-sm font-semibold text-gray-500">No members in register</p>
            <p className="text-xs text-gray-400 mt-1">Add shareholders from Company Master → Shareholding tab</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Folio', 'Member Name', 'Father/Husband', 'PAN', 'Share Class', 'Shares', 'Distinctive Nos', 'Face Value', 'Amount Paid', 'Total', 'Mode', 'Date of Entry', 'Status'].map(h => (
                    <th key={h} className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {shareholders.map((s, idx) => (
                  <tr key={s.id} className={`border-b border-gray-50 hover:bg-gray-50 transition ${!s.is_active ? 'opacity-60' : ''}`}>
                    <td className="px-3 py-3 text-xs font-mono text-gray-500">{s.folio_number || `F${String(idx+1).padStart(3,'0')}`}</td>
                    <td className="px-3 py-3">
                      <p className="text-sm font-semibold text-gray-800">{s.member_name}</p>
                      {s.address && <p className="text-xs text-gray-400 max-w-40 truncate">{s.address}</p>}
                    </td>
                    <td className="px-3 py-3 text-sm text-gray-600">{s.father_husband_name || '-'}</td>
                    <td className="px-3 py-3 text-xs font-mono text-gray-600">{s.pan || '-'}</td>
                    <td className="px-3 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#eff6ff', color: '#00206E', borderColor: '#bfdbfe' }}>
                        {s.share_class}
                      </span>
                    </td>
                    <td className="px-3 py-3 text-sm font-bold" style={{ color: '#00206E' }}>{Number(s.no_of_shares).toLocaleString('en-IN')}</td>
                    <td className="px-3 py-3 text-xs text-gray-500">
                      {s.distinctive_from && s.distinctive_to ? `${s.distinctive_from} - ${s.distinctive_to}` : '-'}
                    </td>
                    <td className="px-3 py-3 text-sm text-gray-600">₹{s.face_value}</td>
                    <td className="px-3 py-3 text-sm text-gray-600">₹{s.amount_paid}</td>
                    <td className="px-3 py-3 text-sm font-semibold text-gray-800">₹{Number(s.total_amount || 0).toLocaleString('en-IN')}</td>
                    <td className="px-3 py-3 text-xs text-gray-500">{s.mode_of_acquisition}</td>
                    <td className="px-3 py-3 text-xs text-gray-600">
                      {s.date_of_entry ? new Date(s.date_of_entry).toLocaleDateString('en-IN') :
                       s.date_of_allotment ? new Date(s.date_of_allotment).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-3 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${
                        s.is_active ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-red-50 text-red-600 border-red-100'
                      }`}>
                        {s.is_active ? 'Active' : 'Ceased'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── REGISTER OF DIRECTORS & KMP ─────────────────────────────────────────────
function DirectorsRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [directors, setDirectors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies/${company.id}/directors`, { headers })
      .then(r => r.json()).then(d => setDirectors(Array.isArray(d) ? d : [])).catch(() => setDirectors([])).finally(() => setLoading(false));
  }, [company.id]);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Register of Directors & KMP</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · MBP-1 Format · Section 170</p>
          </div>
        </div>
        <span className="px-3 py-1.5 rounded-xl text-xs font-semibold border border-gray-200 text-gray-500">
          Managed from Company Master → Directors tab
        </span>
      </div>

      <div className="grid grid-cols-4 gap-4">
        {[
          { label: 'Total Directors', value: directors.length, color: '#00206E' },
          { label: 'Active', value: directors.filter(d => d.is_active).length, color: '#059669' },
          { label: 'Ceased', value: directors.filter(d => !d.is_active).length, color: '#dc2626' },
          { label: 'DIN KYC Pending', value: directors.filter(d => d.din_kyc_status === 'Pending' && d.is_active).length, color: '#FF8400' },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <p className="text-2xl font-bold" style={{ color: s.color }}>{loading ? '—' : s.value}</p>
            <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>MBP-1 — Register of Directors & KMP</p>
          <span className="px-3 py-1 rounded-xl text-xs font-semibold" style={{ background: '#fffbeb', color: '#d97706' }}>Section 170 · Companies Act 2013</span>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading register...</div>
        ) : directors.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#fffbeb', color: '#d97706' }}>{Icons.directors}</div>
            <p className="text-sm font-semibold text-gray-500">No directors in register</p>
            <p className="text-xs text-gray-400 mt-1">Add directors from Company Master → Directors tab</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Name', 'Designation', 'DIN', 'PAN', 'Appointment Date', 'Board Resolution', 'DIR-12 SRN', 'DIN KYC', 'DSC Expiry', 'Cessation', 'Status'].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {directors.map(d => (
                  <tr key={d.id} className={`border-b border-gray-50 hover:bg-gray-50 transition ${!d.is_active ? 'opacity-60' : ''}`}>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                          style={{ background: d.is_active ? '#00206E' : '#9ca3af' }}>
                          {d.director_name.charAt(0)}
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-800">{d.director_name}</p>
                          {d.email && <p className="text-xs text-gray-400">{d.email}</p>}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#eff6ff', color: '#00206E', borderColor: '#bfdbfe' }}>
                        {d.designation}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-600">{d.din || '-'}</td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-600">{d.pan || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {d.appointment_date ? new Date(d.appointment_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {d.board_resolution_date ? new Date(d.board_resolution_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3">
                      {d.form_dir12_filed
                        ? <span className="text-xs font-semibold text-emerald-600">✓ {d.form_dir12_srn || 'Filed'}</span>
                        : <span className="text-xs text-amber-600 font-semibold">Pending</span>}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        d.din_kyc_status === 'Done' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-amber-50 text-amber-700 border-amber-100'
                      }`}>
                        {d.din_kyc_status || 'Pending'}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      {d.dsc_expiry ? (
                        <span className={`text-xs font-semibold ${new Date(d.dsc_expiry) < new Date() ? 'text-red-600' : 'text-gray-700'}`}>
                          {new Date(d.dsc_expiry).toLocaleDateString('en-IN')}
                        </span>
                      ) : '-'}
                    </td>
                    <td className="px-4 py-3 text-xs text-gray-500">
                      {d.cessation_date ? new Date(d.cessation_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        d.is_active ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-red-50 text-red-600 border-red-100'
                      }`}>
                        {d.is_active ? 'Active' : 'Ceased'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── CHARGES REGISTER ────────────────────────────────────────────────────────
export function ChargesRegister({ company, onBack, entity }) {
  const llp = !!entity?.isLLP;
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);

  const EMPTY = {
    charge_id_mca: '', charge_holder: '', charge_holder_address: '',
    charge_holder_type: 'Bank', date_of_creation: '', date_of_modification: '',
    amount_secured: '', currency: 'INR', property_particulars: '',
    charge_description: '', chg1_srn: '', chg1_filed_date: '',
    chg4_srn: '', chg4_filed_date: '', status: 'Active',
    date_of_satisfaction: '', satisfaction_srn: '', notes: '',
  };
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies/${company.id}/charges`, { headers })
      .then(r => r.json()).then(d => setCharges(Array.isArray(d) ? d : [])).catch(() => setCharges([])).finally(() => setLoading(false));
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [company.id]);

  const fetchCharges = async () => {
    const res = await fetch(`${BASE}/api/mca/companies/${company.id}/charges`, { headers });
    const data = await res.json();
    setCharges(Array.isArray(data) ? data : []);
  };

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/charges/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/charges`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      await fetchCharges();
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = c => {
    setForm({
      charge_id_mca: c.charge_id_mca || '', charge_holder: c.charge_holder || '',
      charge_holder_address: c.charge_holder_address || '',
      charge_holder_type: c.charge_holder_type || 'Bank',
      date_of_creation: c.date_of_creation ? String(c.date_of_creation).slice(0,10) : '',
      date_of_modification: c.date_of_modification ? String(c.date_of_modification).slice(0,10) : '',
      amount_secured: c.amount_secured || '', currency: c.currency || 'INR',
      property_particulars: c.property_particulars || '',
      charge_description: c.charge_description || '',
      chg1_srn: c.chg1_srn || '',
      chg1_filed_date: c.chg1_filed_date ? String(c.chg1_filed_date).slice(0,10) : '',
      chg4_srn: c.chg4_srn || '',
      chg4_filed_date: c.chg4_filed_date ? String(c.chg4_filed_date).slice(0,10) : '',
      status: c.status || 'Active',
      date_of_satisfaction: c.date_of_satisfaction ? String(c.date_of_satisfaction).slice(0,10) : '',
      satisfaction_srn: c.satisfaction_srn || '', notes: c.notes || '',
    });
    setEditingId(c.id); setShowForm(true);
  };

  const handleDelete = async c => {
    if (!window.confirm(`Delete charge against "${c.charge_holder}"?`)) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/charges/${c.id}`, { method: 'DELETE', headers });
    await fetchCharges();
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Register of Charges</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · {llp ? 'LLP Act, 2008 — charge registration (2022 Amendment) · CHG-1 / CHG-4' : 'CHG-7 Format · Section 85'}</p>
          </div>
        </div>
        <button onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold shadow-sm"
          style={{ background: '#00206E' }}>
          {Icons.add} Add Charge
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {[
          { label: 'Total Charges', value: charges.length, color: '#00206E' },
          { label: 'Active', value: charges.filter(c => c.status === 'Active').length, color: '#dc2626' },
          { label: 'Satisfied', value: charges.filter(c => c.status === 'Satisfied').length, color: '#059669' },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <p className="text-2xl font-bold" style={{ color: s.color }}>{loading ? '—' : s.value}</p>
            <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
          </div>
        ))}
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #fef2f2, #fff7ed)' }}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-sm" style={{ background: '#dc2626' }}>{Icons.charges}</div>
              <div>
                <p className="text-sm font-bold" style={{ color: '#00206E' }}>{editingId ? 'Edit Charge' : 'Register New Charge'}</p>
                <p className="text-xs text-gray-400">{llp ? 'Charge registration under the LLP Act, 2008 (2022 Amendment applying Companies Act s.77–87)' : 'CHG-7 Format · Section 85 of Companies Act 2013'}</p>
              </div>
            </div>
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">{Icons.close}</button>
          </div>
          <div className="p-6 space-y-5">
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Charge Holder Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">MCA Charge ID</label>
                  <input value={form.charge_id_mca} onChange={e => setForm(f => ({ ...f, charge_id_mca: e.target.value }))} className={ic} placeholder="From MCA portal" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Charge Holder *</label>
                  <input required value={form.charge_holder} onChange={e => setForm(f => ({ ...f, charge_holder: e.target.value }))} className={ic} placeholder="Bank / FI name" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Holder Type</label>
                  <select value={form.charge_holder_type} onChange={e => setForm(f => ({ ...f, charge_holder_type: e.target.value }))} className={ic}>
                    <option>Bank</option><option>NBFC</option><option>Financial Institution</option>
                    <option>Individual</option><option>Other</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                  <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                    <option>Active</option><option>Modified</option><option>Satisfied</option>
                  </select>
                </div>
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Address</label>
                  <input value={form.charge_holder_address} onChange={e => setForm(f => ({ ...f, charge_holder_address: e.target.value }))} className={ic} />
                </div>
              </div>
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Charge Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Date of Creation</label>
                  <input type="date" value={form.date_of_creation} onChange={e => setForm(f => ({ ...f, date_of_creation: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Date of Modification</label>
                  <input type="date" value={form.date_of_modification} onChange={e => setForm(f => ({ ...f, date_of_modification: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Amount Secured (₹)</label>
                  <input type="number" value={form.amount_secured} onChange={e => setForm(f => ({ ...f, amount_secured: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">CHG-1 SRN</label>
                  <input value={form.chg1_srn} onChange={e => setForm(f => ({ ...f, chg1_srn: e.target.value.toUpperCase() }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">CHG-1 Filed Date</label>
                  <input type="date" value={form.chg1_filed_date} onChange={e => setForm(f => ({ ...f, chg1_filed_date: e.target.value }))} className={ic} />
                </div>
                <div className="col-span-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Property / Assets Charged</label>
                  <input value={form.property_particulars} onChange={e => setForm(f => ({ ...f, property_particulars: e.target.value }))} className={ic} />
                </div>
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Charge Description</label>
                  <input value={form.charge_description} onChange={e => setForm(f => ({ ...f, charge_description: e.target.value }))} className={ic} />
                </div>
              </div>
            </div>
            {form.status === 'Satisfied' && (
              <div>
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Satisfaction Details</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">Date of Satisfaction</label>
                    <input type="date" value={form.date_of_satisfaction} onChange={e => setForm(f => ({ ...f, date_of_satisfaction: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">CHG-4 SRN</label>
                    <input value={form.chg4_srn} onChange={e => setForm(f => ({ ...f, chg4_srn: e.target.value.toUpperCase() }))} className={ic} />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">CHG-4 Filed Date</label>
                    <input type="date" value={form.chg4_filed_date} onChange={e => setForm(f => ({ ...f, chg4_filed_date: e.target.value }))} className={ic} />
                  </div>
                </div>
              </div>
            )}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
              <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} className={ic} />
            </div>
          </div>
          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium hover:bg-white transition">Cancel</button>
            <button type="submit" disabled={saving}
              className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-60 shadow-sm"
              style={{ background: '#00206E' }}>
              {saving ? 'Saving...' : editingId ? 'Update Charge' : 'Register Charge'}
            </button>
          </div>
        </form>
      )}

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>CHG-7 — Charge Register</p>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading...</div>
        ) : charges.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#fef2f2', color: '#dc2626' }}>{Icons.charges}</div>
            <p className="text-sm font-semibold text-gray-500">No charges registered</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Charge ID', 'Holder', 'Type', 'Date of Creation', 'Amount Secured', 'CHG-1 SRN', 'CHG-4 SRN', 'Satisfaction Date', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {charges.map(c => (
                  <tr key={c.id} className="border-b border-gray-50 hover:bg-gray-50 transition">
                    <td className="px-4 py-3 text-xs font-mono text-gray-500">{c.charge_id_mca || '-'}</td>
                    <td className="px-4 py-3">
                      <p className="text-sm font-semibold text-gray-800">{c.charge_holder}</p>
                      {c.charge_holder_address && <p className="text-xs text-gray-400 max-w-40 truncate">{c.charge_holder_address}</p>}
                    </td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#eff6ff', color: '#00206E', borderColor: '#bfdbfe' }}>
                        {c.charge_holder_type}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {c.date_of_creation ? new Date(c.date_of_creation).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm font-bold" style={{ color: '#dc2626' }}>
                      {c.amount_secured ? `₹${Number(c.amount_secured).toLocaleString('en-IN')}` : '-'}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-600">{c.chg1_srn || '-'}</td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-600">{c.chg4_srn || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {c.date_of_satisfaction ? new Date(c.date_of_satisfaction).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        c.status === 'Active' ? 'bg-red-50 text-red-600 border-red-100' :
                        c.status === 'Satisfied' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' :
                        'bg-amber-50 text-amber-700 border-amber-100'
                      }`}>
                        {c.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 relative" data-kebab>
                      <button onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === c.id ? null : c.id); }}
                        className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center" data-kebab>
                        {Icons.kebab}
                      </button>
                      {openMenuId === c.id && (
                        <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-44 p-1.5" data-kebab>
                          <button onClick={() => { handleEdit(c); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">{Icons.edit} Edit</button>
                          <div className="border-t border-gray-100 my-1" />
                          <button onClick={() => { handleDelete(c); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50">{Icons.delete} Delete</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── CONTRACTS REGISTER (AOC-2) ──────────────────────────────────────────────
export function ContractsRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);

  const EMPTY = {
    related_party_name: '', related_party_relationship: '', related_party_pan: '',
    contract_date: '', contract_description: '', contract_duration: '',
    contract_value: '', salient_terms: '',
    board_approval_date: '', board_resolution_number: '',
    shareholder_approval_required: false, shareholder_approval_date: '',
    aoc2_applicable: true, financial_year: '', status: 'Active', notes: '',
  };
  const [form, setForm] = useState(EMPTY);

  const fetchContracts = async () => {
    const res = await fetch(`${BASE}/api/mca/companies/${company.id}/contracts`, { headers });
    const data = await res.json();
    setContracts(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    fetchContracts().finally(() => setLoading(false));
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [company.id]);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/contracts/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/contracts`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      await fetchContracts();
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = c => {
    setForm({
      related_party_name: c.related_party_name || '',
      related_party_relationship: c.related_party_relationship || '',
      related_party_pan: c.related_party_pan || '',
      contract_date: c.contract_date ? String(c.contract_date).slice(0,10) : '',
      contract_description: c.contract_description || '',
      contract_duration: c.contract_duration || '',
      contract_value: c.contract_value || '',
      salient_terms: c.salient_terms || '',
      board_approval_date: c.board_approval_date ? String(c.board_approval_date).slice(0,10) : '',
      board_resolution_number: c.board_resolution_number || '',
      shareholder_approval_required: c.shareholder_approval_required || false,
      shareholder_approval_date: c.shareholder_approval_date ? String(c.shareholder_approval_date).slice(0,10) : '',
      aoc2_applicable: c.aoc2_applicable !== false,
      financial_year: c.financial_year || '',
      status: c.status || 'Active', notes: c.notes || '',
    });
    setEditingId(c.id); setShowForm(true);
  };

  const handleDelete = async c => {
    if (!window.confirm(`Delete contract with "${c.related_party_name}"?`)) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/contracts/${c.id}`, { method: 'DELETE', headers });
    await fetchContracts();
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Register of Contracts — AOC-2</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · Section 189 · Related Party Transactions</p>
          </div>
        </div>
        <button onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold shadow-sm"
          style={{ background: '#FF8400' }}>
          {Icons.add} Add Contract
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #fff7ed, #fffbeb)' }}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-sm" style={{ background: '#FF8400' }}>{Icons.contracts}</div>
              <div>
                <p className="text-sm font-bold" style={{ color: '#00206E' }}>{editingId ? 'Edit Contract' : 'Add Related Party Contract'}</p>
                <p className="text-xs text-gray-400">AOC-2 · Section 189 of Companies Act 2013</p>
              </div>
            </div>
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">{Icons.close}</button>
          </div>
          <div className="p-6 space-y-5">
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Related Party Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div className="col-span-2">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Related Party Name *</label>
                  <input required value={form.related_party_name} onChange={e => setForm(f => ({ ...f, related_party_name: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Relationship</label>
                  <input value={form.related_party_relationship} onChange={e => setForm(f => ({ ...f, related_party_relationship: e.target.value }))} className={ic} placeholder="e.g. Subsidiary" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">PAN</label>
                  <input value={form.related_party_pan} onChange={e => setForm(f => ({ ...f, related_party_pan: e.target.value.toUpperCase() }))} className={ic} />
                </div>
              </div>
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Contract Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Contract Date</label>
                  <input type="date" value={form.contract_date} onChange={e => setForm(f => ({ ...f, contract_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Duration</label>
                  <input value={form.contract_duration} onChange={e => setForm(f => ({ ...f, contract_duration: e.target.value }))} className={ic} placeholder="e.g. 2 years" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Contract Value (₹)</label>
                  <input type="number" value={form.contract_value} onChange={e => setForm(f => ({ ...f, contract_value: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Financial Year</label>
                  <input value={form.financial_year} onChange={e => setForm(f => ({ ...f, financial_year: e.target.value }))} className={ic} placeholder="2024-25" />
                </div>
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Contract Description *</label>
                  <input required value={form.contract_description} onChange={e => setForm(f => ({ ...f, contract_description: e.target.value }))} className={ic} />
                </div>
                <div className="col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Salient Terms</label>
                  <input value={form.salient_terms} onChange={e => setForm(f => ({ ...f, salient_terms: e.target.value }))} className={ic} />
                </div>
              </div>
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Approval Details</p>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Board Approval Date</label>
                  <input type="date" value={form.board_approval_date} onChange={e => setForm(f => ({ ...f, board_approval_date: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Board Resolution No.</label>
                  <input value={form.board_resolution_number} onChange={e => setForm(f => ({ ...f, board_resolution_number: e.target.value }))} className={ic} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Shareholder Approval</label>
                  <select value={form.shareholder_approval_required ? 'yes' : 'no'} onChange={e => setForm(f => ({ ...f, shareholder_approval_required: e.target.value === 'yes' }))} className={ic}>
                    <option value="no">Not Required</option><option value="yes">Required</option>
                  </select>
                </div>
                {form.shareholder_approval_required && (
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">Approval Date</label>
                    <input type="date" value={form.shareholder_approval_date} onChange={e => setForm(f => ({ ...f, shareholder_approval_date: e.target.value }))} className={ic} />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                  <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                    <option>Active</option><option>Expired</option><option>Terminated</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); setForm(EMPTY); }}
              className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium hover:bg-white transition">Cancel</button>
            <button type="submit" disabled={saving}
              className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-60 shadow-sm"
              style={{ background: '#FF8400' }}>
              {saving ? 'Saving...' : editingId ? 'Update' : 'Save Contract'}
            </button>
          </div>
        </form>
      )}

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>AOC-2 — Related Party Contracts</p>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading...</div>
        ) : contracts.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#fff7ed', color: '#FF8400' }}>{Icons.contracts}</div>
            <p className="text-sm font-semibold text-gray-500">No contracts registered</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Related Party', 'Relationship', 'Description', 'Value', 'FY', 'Board Approval', 'Shareholder', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {contracts.map(c => (
                  <tr key={c.id} className="border-b border-gray-50 hover:bg-gray-50 transition">
                    <td className="px-4 py-3">
                      <p className="text-sm font-semibold text-gray-800">{c.related_party_name}</p>
                      {c.related_party_pan && <p className="text-xs font-mono text-gray-400">{c.related_party_pan}</p>}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{c.related_party_relationship || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 max-w-48 truncate">{c.contract_description}</td>
                    <td className="px-4 py-3 text-sm font-semibold" style={{ color: '#FF8400' }}>
                      {c.contract_value ? `₹${Number(c.contract_value).toLocaleString('en-IN')}` : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{c.financial_year || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {c.board_approval_date ? new Date(c.board_approval_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        c.shareholder_approval_required ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-gray-50 text-gray-500 border-gray-100'
                      }`}>
                        {c.shareholder_approval_required ? 'Required' : 'N/A'}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        c.status === 'Active' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-gray-50 text-gray-500 border-gray-200'
                      }`}>
                        {c.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 relative" data-kebab>
                      <button onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === c.id ? null : c.id); }}
                        className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center" data-kebab>
                        {Icons.kebab}
                      </button>
                      {openMenuId === c.id && (
                        <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-44 p-1.5" data-kebab>
                          <button onClick={() => { handleEdit(c); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">{Icons.edit} Edit</button>
                          <div className="border-t border-gray-100 my-1" />
                          <button onClick={() => { handleDelete(c); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50">{Icons.delete} Delete</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── SHARE TRANSFER REGISTER ─────────────────────────────────────────────────
export function TransfersRegister({ company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [transfers, setTransfers] = useState([]);
  const [shareholders, setShareholders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);

  const EMPTY = {
    from_shareholder_id: '', to_shareholder_id: '',
    transfer_date: '', no_of_shares: '', share_class: 'Equity',
    distinctive_from: '', distinctive_to: '', face_value: '10',
    consideration_per_share: '10', sh4_reference: '', board_resolution_date: '',
    stamp_duty_paid: '', stamp_duty_reference: '', status: 'Registered', remarks: '',
  };
  const [form, setForm] = useState(EMPTY);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [tRes, sRes] = await Promise.all([
        fetch(`${BASE}/api/mca/companies/${company.id}/transfers`, { headers }),
        fetch(`${BASE}/api/mca/companies/${company.id}/shareholders`, { headers }),
      ]);
      const [tData, sData] = await Promise.all([tRes.json(), sRes.json()]);
      setTransfers(Array.isArray(tData) ? tData : []);
      setShareholders(Array.isArray(sData) ? sData : []);
    } catch (e) { setTransfers([]); setShareholders([]); }
    finally { setLoading(false); }
  }, [company.id]);

  useEffect(() => {
    fetchAll();
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [fetchAll]);

  const pickFrom = (shareholderId) => {
    const sh = shareholders.find(s => String(s.id) === String(shareholderId));
    setForm(f => ({
      ...f, from_shareholder_id: shareholderId,
      share_class: sh?.share_class || f.share_class, face_value: sh?.face_value || f.face_value,
      distinctive_from: sh?.distinctive_from || '', distinctive_to: sh?.distinctive_to || '',
    }));
  };

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const totalConsideration = (Number(form.no_of_shares) || 0) * (Number(form.consideration_per_share) || 0);
      const url = editingId
        ? `${BASE}/api/mca/companies/${company.id}/transfers/${editingId}`
        : `${BASE}/api/mca/companies/${company.id}/transfers`;
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, total_consideration: totalConsideration }),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message || 'Could not save'); return; }
      await fetchAll();
      setForm(EMPTY); setEditingId(null); setShowForm(false);
    } catch (e) { alert('Server error'); }
    finally { setSaving(false); }
  };

  const handleEdit = t => {
    setForm({
      from_shareholder_id: t.from_shareholder_id || '', to_shareholder_id: t.to_shareholder_id || '',
      transfer_date: t.transfer_date ? String(t.transfer_date).slice(0, 10) : '',
      no_of_shares: t.no_of_shares || '', share_class: t.share_class || 'Equity',
      distinctive_from: t.distinctive_from || '', distinctive_to: t.distinctive_to || '',
      face_value: t.face_value || '10', consideration_per_share: t.consideration_per_share || '10',
      sh4_reference: t.sh4_reference || '',
      board_resolution_date: t.board_resolution_date ? String(t.board_resolution_date).slice(0, 10) : '',
      stamp_duty_paid: t.stamp_duty_paid || '', stamp_duty_reference: t.stamp_duty_reference || '',
      status: t.status || 'Registered', remarks: t.remarks || '',
    });
    setEditingId(t.id); setShowForm(true);
  };

  const handleDelete = async t => {
    if (!window.confirm('Delete this transfer record? This does not reverse any shareholder balance changes already applied.')) return;
    await fetch(`${BASE}/api/mca/companies/${company.id}/transfers/${t.id}`, { method: 'DELETE', headers });
    await fetchAll();
  };

  const ic = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300";

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">Share Transfer Register</p>
            <p className="text-xs text-gray-400 mt-0.5">{company.company_name} · SH-4 Format · Section 56</p>
          </div>
        </div>
        <button onClick={() => { setForm(EMPTY); setEditingId(null); setShowForm(true); }}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold shadow-sm"
          style={{ background: '#00206E' }}>
          {Icons.add} Record Transfer
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSave} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 space-y-4">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>{editingId ? 'Edit Transfer' : 'Record Transfer'}</p>
          <p className="text-xs text-gray-400 -mt-2">Transferor and transferee must already exist under the Shareholding tab — add a new member there first if they're not on record yet.</p>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Transferor (from)</label>
              <select required className={ic} value={form.from_shareholder_id} onChange={e => pickFrom(e.target.value)}>
                <option value="">Select shareholder…</option>
                {shareholders.map(s => <option key={s.id} value={s.id}>{s.member_name} — Folio {s.folio_number} ({s.no_of_shares} shares)</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Transferee (to)</label>
              <select required className={ic} value={form.to_shareholder_id} onChange={e => setForm(f => ({ ...f, to_shareholder_id: e.target.value }))}>
                <option value="">Select shareholder…</option>
                {shareholders.filter(s => String(s.id) !== String(form.from_shareholder_id)).map(s => <option key={s.id} value={s.id}>{s.member_name} — Folio {s.folio_number}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Transfer Date *</label>
              <input required type="date" className={ic} value={form.transfer_date} onChange={e => setForm(f => ({ ...f, transfer_date: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">No. of Shares *</label>
              <input required type="number" className={ic} value={form.no_of_shares} onChange={e => setForm(f => ({ ...f, no_of_shares: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Share Class</label>
              <input className={ic} value={form.share_class} onChange={e => setForm(f => ({ ...f, share_class: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Face Value (Rs.)</label>
              <input type="number" className={ic} value={form.face_value} onChange={e => setForm(f => ({ ...f, face_value: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Distinctive From</label>
              <input className={ic} value={form.distinctive_from} onChange={e => setForm(f => ({ ...f, distinctive_from: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Distinctive To</label>
              <input className={ic} value={form.distinctive_to} onChange={e => setForm(f => ({ ...f, distinctive_to: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Consideration/Share (Rs.)</label>
              <input type="number" className={ic} value={form.consideration_per_share} onChange={e => setForm(f => ({ ...f, consideration_per_share: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">SH-4 Reference</label>
              <input className={ic} value={form.sh4_reference} onChange={e => setForm(f => ({ ...f, sh4_reference: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Board Resolution Date</label>
              <input type="date" className={ic} value={form.board_resolution_date} onChange={e => setForm(f => ({ ...f, board_resolution_date: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
              <select className={ic} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                <option>Registered</option><option>Pending</option><option>Completed</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Stamp Duty Paid (Rs.)</label>
              <input type="number" className={ic} value={form.stamp_duty_paid} onChange={e => setForm(f => ({ ...f, stamp_duty_paid: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Stamp Duty Reference</label>
              <input className={ic} value={form.stamp_duty_reference} onChange={e => setForm(f => ({ ...f, stamp_duty_reference: e.target.value }))} />
            </div>
            <div className="col-span-3">
              <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
              <input className={ic} value={form.remarks} onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
            </div>
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={() => { setShowForm(false); setEditingId(null); }} className="px-4 py-2 rounded-lg border border-gray-200 text-gray-600 text-sm font-semibold">Cancel</button>
            <button type="submit" disabled={saving} className="px-4 py-2 rounded-lg text-white text-sm font-semibold disabled:opacity-50" style={{ background: '#00206E' }}>{saving ? 'Saving…' : 'Save'}</button>
          </div>
        </form>
      )}

      {(() => {
        // A transfer only moves existing shares between members — it never
        // changes the company's share count. So "Total Shares" must come from
        // the Register of Members (current holdings), NOT from summing the
        // transfer rows: the same shares moving A→B→C would be counted twice.
        const sharesInIssue = shareholders
          .filter(s => s.is_active !== false)
          .reduce((sum, s) => sum + (Number(s.no_of_shares) || 0), 0)
          || Math.round((Number(company.paid_up_capital) || 0) / (Number(shareholders[0]?.face_value) || 10));
        const sharesMoved = transfers.reduce((s, t) => s + (Number(t.no_of_shares) || 0), 0);
        return (
          <div className="grid grid-cols-4 gap-4">
            {[
              { label: 'Total Transfers', value: transfers.length, color: '#00206E' },
              { label: 'Completed', value: transfers.filter(t => t.status === 'Completed').length, color: '#059669' },
              { label: 'Pending', value: transfers.filter(t => t.status === 'Pending').length, color: '#FF8400' },
              { label: 'Total Shares (in issue)', value: sharesInIssue.toLocaleString('en-IN'), color: '#0891b2',
                sub: `${sharesMoved.toLocaleString('en-IN')} shares moved across ${transfers.length} transfer${transfers.length !== 1 ? 's' : ''}` },
            ].map(s => (
              <div key={s.label} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
                <p className="text-2xl font-bold" style={{ color: s.color }}>{loading ? '—' : s.value}</p>
                <p className="text-xs text-gray-400 mt-1 font-medium">{s.label}</p>
                {s.sub && !loading && <p className="text-[11px] text-gray-400 mt-0.5">{s.sub}</p>}
              </div>
            ))}
          </div>
        );
      })()}

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>SH-4 — Transfer Register</p>
          <span className="px-3 py-1 rounded-xl text-xs font-semibold" style={{ background: '#ecfeff', color: '#0891b2' }}>Section 56 · Companies Act 2013</span>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading...</div>
        ) : transfers.length === 0 ? (
          <div className="py-14 text-center">
            <div className="w-12 h-12 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: '#ecfeff', color: '#0891b2' }}>{Icons.transfers}</div>
            <p className="text-sm font-semibold text-gray-500">No share transfers recorded</p>
            <p className="text-xs text-gray-400 mt-1">Click "Record Transfer" above, or sync one from an Event Filing case's Documents tab</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['Transfer Date', 'Transferor', 'Transferee', 'Share Class', 'Shares', 'Distinctive Nos', 'Consideration', 'SH-4 Ref', 'Board Resolution', 'Stamp Duty', 'Status', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {transfers.map(t => (
                  <tr key={t.id} className="border-b border-gray-50 hover:bg-gray-50 transition">
                    <td className="px-4 py-3 text-sm font-medium text-gray-800">
                      {t.transfer_date ? new Date(t.transfer_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 font-medium">{t.from_shareholder_name || t.from_person_name || '-'}{t.from_folio_number ? <span className="text-gray-400 font-normal"> · Folio {t.from_folio_number}</span> : ''}</td>
                    <td className="px-4 py-3 text-sm text-gray-700 font-medium">{t.to_shareholder_name || t.to_person_name || '-'}{t.to_folio_number ? <span className="text-gray-400 font-normal"> · Folio {t.to_folio_number}</span> : ''}</td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{ background: '#ecfeff', color: '#0891b2', borderColor: '#a5f3fc' }}>
                        {t.share_class}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm font-bold" style={{ color: '#00206E' }}>{Number(t.no_of_shares).toLocaleString('en-IN')}</td>
                    <td className="px-4 py-3 text-xs text-gray-500">
                      {t.distinctive_from && t.distinctive_to ? `${t.distinctive_from} - ${t.distinctive_to}` : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {t.total_consideration ? `₹${Number(t.total_consideration).toLocaleString('en-IN')}` : '-'}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-600">{t.sh4_reference || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {t.board_resolution_date ? new Date(t.board_resolution_date).toLocaleDateString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {t.stamp_duty_paid ? `₹${Number(t.stamp_duty_paid).toLocaleString('en-IN')}` : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        t.status === 'Completed' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' :
                        t.status === 'Pending' ? 'bg-amber-50 text-amber-700 border-amber-100' :
                        'bg-blue-50 text-blue-700 border-blue-100'
                      }`}>
                        {t.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 relative" data-kebab onClick={e => e.stopPropagation()}>
                      <button onClick={() => setOpenMenuId(openMenuId === t.id ? null : t.id)}
                        className="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center" data-kebab>
                        {Icons.kebab}
                      </button>
                      {openMenuId === t.id && (
                        <div className="absolute right-0 top-10 bg-white border border-gray-200 rounded-2xl shadow-xl z-50 w-40 p-1.5" data-kebab>
                          <button onClick={() => { handleEdit(t); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 transition">
                            {Icons.edit} Edit
                          </button>
                          <div className="border-t border-gray-100 my-1" />
                          <button onClick={() => { handleDelete(t); setOpenMenuId(null); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50 transition">
                            {Icons.delete} Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── SHAREHOLDING REGISTER (Certificates + Allotment) ───────────────────────
function ShareholdingRegister({ type, company, onBack }) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const [shareholders, setShareholders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies/${company.id}/shareholders`, { headers })
      .then(r => r.json()).then(d => setShareholders(Array.isArray(d) ? d : [])).catch(() => setShareholders([])).finally(() => setLoading(false));
  }, [company.id]);

  const isCertificates = type === 'certificates';

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && <button onClick={onBack} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>}
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">
              {isCertificates ? 'Register of Share Certificates' : 'Register of Allotment'}
            </p>
            <p className="text-xs text-gray-400 mt-0.5">
              {company.company_name} · {isCertificates ? 'SH-1 · Section 46' : 'PAS-3 · Section 42'}
            </p>
          </div>
        </div>
        <span className="px-3 py-1.5 rounded-xl text-xs font-semibold border border-gray-200 text-gray-500">
          Managed from Company Master → Shareholding tab
        </span>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>
            {isCertificates ? 'SH-1 — Share Certificates' : 'Allotment Register'}
          </p>
          <span className="px-3 py-1 rounded-xl text-xs font-semibold" style={{
            background: isCertificates ? '#eff6ff' : '#f5f3ff',
            color: isCertificates ? '#00206E' : '#7c3aed'
          }}>
            {isCertificates ? 'Section 46' : 'Section 42'} · Companies Act 2013
          </span>
        </div>
        {loading ? (
          <div className="py-14 text-center text-gray-400 text-sm">Loading...</div>
        ) : shareholders.length === 0 ? (
          <div className="py-14 text-center">
            <p className="text-sm font-semibold text-gray-500">No entries found</p>
            <p className="text-xs text-gray-400 mt-1">Add shareholding data from Company Master → Shareholding tab</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {isCertificates
                    ? ['Folio', 'Member', 'Share Class', 'Cert. Nos (Distinctive)', 'Shares', 'Face Value', 'Date of Issue', 'Status'].map(h => (
                        <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                      ))
                    : ['Folio', 'Allottee', 'Share Class', 'Shares Allotted', 'Face Value', 'Amount Paid', 'Total', 'Mode', 'Date of Allotment', 'Status'].map(h => (
                        <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>
                      ))
                  }
                </tr>
              </thead>
              <tbody>
                {shareholders.filter(s => !isCertificates || s.mode_of_acquisition === 'Allotment' || true).map((s, idx) => (
                  <tr key={s.id} className={`border-b border-gray-50 hover:bg-gray-50 transition ${!s.is_active ? 'opacity-60' : ''}`}>
                    <td className="px-4 py-3 text-xs font-mono text-gray-500">{s.folio_number || `F${String(idx+1).padStart(3,'0')}`}</td>
                    <td className="px-4 py-3">
                      <p className="text-sm font-semibold text-gray-800">{s.member_name}</p>
                    </td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium border" style={{
                        background: isCertificates ? '#eff6ff' : '#f5f3ff',
                        color: isCertificates ? '#00206E' : '#7c3aed',
                        borderColor: isCertificates ? '#bfdbfe' : '#ddd6fe',
                      }}>
                        {s.share_class}
                      </span>
                    </td>
                    {isCertificates ? (
                      <>
                        <td className="px-4 py-3 text-xs text-gray-500">
                          {s.distinctive_from && s.distinctive_to ? `${s.distinctive_from} - ${s.distinctive_to}` : '-'}
                        </td>
                        <td className="px-4 py-3 text-sm font-bold" style={{ color: '#00206E' }}>{Number(s.no_of_shares).toLocaleString('en-IN')}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">₹{s.face_value}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {s.date_of_allotment ? new Date(s.date_of_allotment).toLocaleDateString('en-IN') : '-'}
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-4 py-3 text-sm font-bold" style={{ color: '#7c3aed' }}>{Number(s.no_of_shares).toLocaleString('en-IN')}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">₹{s.face_value}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">₹{s.amount_paid}</td>
                        <td className="px-4 py-3 text-sm font-semibold text-gray-800">₹{Number(s.total_amount || 0).toLocaleString('en-IN')}</td>
                        <td className="px-4 py-3 text-xs text-gray-500">{s.mode_of_acquisition}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {s.date_of_allotment ? new Date(s.date_of_allotment).toLocaleDateString('en-IN') : '-'}
                        </td>
                      </>
                    )}
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${
                        s.is_active ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-red-50 text-red-600 border-red-100'
                      }`}>
                        {s.is_active ? 'Active' : 'Ceased'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function Registers({ initialRegisterId, initialCompanyId } = {}) {
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };

  const [companies, setCompanies] = useState([]);
  const [activeRegister, setActiveRegister] = useState(initialRegisterId || null);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    fetch(`${BASE}/api/mca/companies`, { headers })
      .then(r => r.json())
      .then(d => {
        const list = Array.isArray(d) ? d : [];
        setCompanies(list);
        if (initialCompanyId) {
          const match = list.find(c => c.id === initialCompanyId);
          if (match) setSelectedCompany(match);
        }
      })
      .catch(() => setCompanies([]));
  }, []);

  // If company selected → show register
  if (activeRegister && selectedCompany) {
    const reg = REGISTERS.find(r => r.id === activeRegister);
    const back = () => { setSelectedCompany(null); setActiveRegister(null); };
    const entity = getEntityProfile(selectedCompany.company_type);

    // Registers that simply do not exist for an LLP (LLP Act, 2008).
    const LLP_NA = {
      'general-meetings': 'Partners\' Meetings',
      'committee-meetings': 'Partners\' Meetings',
      'members': 'Capital Contribution',
      'directors': 'Partners',
      'contracts': null,
      'certificates': null,
      'allotment': null,
      'transfers': null,
    };
    if (entity.isLLP && Object.prototype.hasOwnProperty.call(LLP_NA, activeRegister)) {
      const alt = LLP_NA[activeRegister];
      return (
        <div className="space-y-5">
          <div className="flex items-center gap-3">
            <button onClick={back} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition">{Icons.back}</button>
            <div>
              <p className="text-sm font-bold text-[#0f1f45]">{reg?.label || 'Register'}</p>
              <p className="text-xs text-gray-400 mt-0.5">{selectedCompany.company_name} · LLP</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 text-center">
            <p className="text-sm font-semibold text-gray-600">This register does not apply to an LLP.</p>
            <p className="text-xs text-gray-400 mt-1">
              LLPs are governed by the LLP Act, 2008 — no shares, no AGM, no statutory board committees.
              {alt && <> Use <b>Company Master → {alt}</b> instead.</>}
            </p>
          </div>
        </div>
      );
    }

    if (activeRegister === 'board-meetings') {
      return <BoardMeetingRegister company={selectedCompany} entity={entity} onBack={back} />;
    }
    if (activeRegister === 'charges') {
      return <ChargesRegister company={selectedCompany} entity={entity} onBack={back} />;
    }
    if (activeRegister === 'general-meetings') {
      return <GeneralMeetingRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'committee-meetings') {
      return <CommitteeMeetingRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'members') {
      return <MembersRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'directors') {
      return <DirectorsRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'charges') {
      return <ChargesRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'contracts') {
      return <ContractsRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'transfers') {
      return <TransfersRegister company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }
    if (activeRegister === 'certificates' || activeRegister === 'allotment') {
      return <ShareholdingRegister type={activeRegister} company={selectedCompany} onBack={() => { setSelectedCompany(null); setActiveRegister(null); }} />;
    }

    // Fallback placeholder
    return (
      <div className="space-y-5">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setSelectedCompany(null)}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition"
          >
            {Icons.back}
          </button>
          <div>
            <p className="text-sm font-bold text-[#0f1f45] dark:text-slate-100">{reg?.label}</p>
            <p className="text-xs text-gray-400 mt-0.5">{selectedCompany.company_name}</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 text-center">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: reg?.lightBg, color: reg?.color }}>
            {reg?.icon}
          </div>
          <p className="text-sm font-bold" style={{ color: '#00206E' }}>{reg?.label}</p>
          <p className="text-xs text-gray-400 mt-1 max-w-sm mx-auto">{reg?.description}</p>
          <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold border" style={{ borderColor: reg?.color, color: reg?.color, background: reg?.lightBg }}>
            {reg?.badge}
          </div>
          <p className="text-xs text-gray-400 mt-6">This register will be built in the next phase.</p>
        </div>
      </div>
    );
  }

  // Company selector
  if (activeRegister && !selectedCompany) {
    const reg = REGISTERS.find(r => r.id === activeRegister);
    return (
      <div className="space-y-5">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setActiveRegister(null)}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition"
          >
            {Icons.back}
          </button>
          <p className="text-sm text-gray-500">Back to Registers</p>
        </div>
        <CompanySelector
          companies={companies}
          onSelect={c => setSelectedCompany(c)}
          registerLabel={reg?.label}
          registerIcon={reg?.icon}
          registerColor={reg?.color}
        />
      </div>
    );
  }

  // Main register list
  return (
    <div className="space-y-6">

      {/* Header Banner */}
      <div className="rounded-2xl overflow-hidden relative" style={{ background: 'linear-gradient(135deg, #00206E 0%, #001A5C 100%)' }}>
        <div className="absolute top-0 right-0 w-48 h-48 rounded-full opacity-10" style={{ background: '#FF8400', transform: 'translate(30%, -30%)' }} />
        <div className="relative px-7 py-6 flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 rounded-full" style={{ background: '#FF8400' }} />
              <p className="text-xs font-bold tracking-widest uppercase" style={{ color: '#FF8400' }}>Companies Act 2013</p>
            </div>
            <h2 className="text-xl font-bold text-white">Statutory Registers</h2>
            <p className="text-sm mt-1" style={{ color: '#93c5fd' }}>
              Maintain all mandatory registers in statutory format · Select a register to begin
            </p>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <div className="text-right">
              <p className="text-xs" style={{ color: '#93c5fd' }}>Companies</p>
              <p className="text-lg font-bold text-white">{companies.length}</p>
            </div>
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(255,132,0,0.2)', border: '1px solid rgba(255,132,0,0.3)' }}>
              <span style={{ color: '#FF8400' }}>{Icons.members}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Registers by Section */}
      {SECTIONS.map(section => {
        const sectionRegisters = REGISTERS.filter(r => r.section === section);
        return (
          <div key={section}>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3 px-1">{section}</p>
            <div className="grid grid-cols-1 gap-3">
              {sectionRegisters.map(reg => (
                <button
                  key={reg.id}
                  onClick={() => setActiveRegister(reg.id)}
                  className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-200 text-left overflow-hidden"
                >
                  <div className="px-5 py-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      {/* Icon */}
                      <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all duration-200 group-hover:scale-105"
                        style={{ background: reg.lightBg, color: reg.color }}>
                        {reg.icon}
                      </div>

                      {/* Info */}
                      <div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <p className="text-sm font-bold text-gray-800 group-hover:text-[#00206E] transition">
                            {reg.label}
                          </p>
                          <span className="px-2 py-0.5 rounded-full text-xs font-semibold border"
                            style={{ background: reg.lightBg, color: reg.color, borderColor: `${reg.color}30` }}>
                            {reg.badge}
                          </span>
                        </div>
                        <p className="text-xs text-gray-400 mt-0.5">{reg.description}</p>
                      </div>
                    </div>

                    {/* Arrow */}
                    <div className="flex items-center gap-2 flex-shrink-0 opacity-0 group-hover:opacity-100 transition">
                      <span className="text-xs font-semibold" style={{ color: '#FF8400' }}>Open</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FF8400" strokeWidth="2.5">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                    </div>
                  </div>

                  {/* Bottom accent line */}
                  <div className="h-0.5 w-0 group-hover:w-full transition-all duration-300"
                    style={{ background: `linear-gradient(90deg, ${reg.color}, ${reg.color}50)` }} />
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Registers;